"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3130],{

/***/ 42486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDonationImg02 = function SvgDonationImg02(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 180,
    height: 200,
    viewBox: "0 0 300 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#donationImg02_svg__a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M129.812 104.142a14.998 14.998 0 0 0-2.139-6.353 14.953 14.953 0 0 0-4.691-4.78 14.898 14.898 0 0 0-12.949-1.512l1.082.11a19.78 19.78 0 0 0-12.092 7.745 17.197 17.197 0 0 0-2.714 14.007c1.227 4.754 4.849 8.877 9.485 10.46 2.578.879 5.345.987 8.067 1.08 1.767.06 3.566.114 5.269-.361a11.064 11.064 0 0 0 5.512-3.852 22.668 22.668 0 0 0 3.26-5.985c1.321-3.36 2.269-6.965 1.91-10.559Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M168.305 323.137c-3.85-14.514 4.698-28.661 14.687-38.454 5.323-5.219 11.251-9.756 17.032-14.443a181.852 181.852 0 0 0 15.82-14.284c9.638-9.889 18.044-21.191 23.612-33.895 5.294-12.08 7.796-25.24 6.556-38.422-1.175-12.501-5.645-24.799-13.867-34.39a50.704 50.704 0 0 0-3.233-3.437c-.607-.591-1.536.339-.928.931 9.181 8.937 14.525 21.05 16.333 33.651 1.866 12.995-.056 26.243-4.903 38.393-5.163 12.942-13.374 24.491-22.896 34.569a169.04 169.04 0 0 1-15.274 14.198c-5.744 4.743-11.712 9.224-17.181 14.293-10.079 9.342-19.138 22.193-17.893 36.658.145 1.683.435 3.349.869 4.982a.66.66 0 0 0 .801.438.658.658 0 0 0 .465-.788Z",
    fill: "#004438",
    fillOpacity: 0.05
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M208.617 240.51a134.724 134.724 0 0 1-13.792-33.288 137.543 137.543 0 0 1-4.608-35.754c.044-12.069 1.506-24.44 5.238-35.949 3.542-10.923 9.888-21.339 19.963-27.3a32.552 32.552 0 0 1 16.959-4.49c6.291.06 12.496 1.72 18.164 4.408 5.551 2.633 10.628 6.181 15.317 10.136a112.746 112.746 0 0 1 12.479 12.285c7.6 8.762 13.809 18.907 17.277 30.031 3.614 11.592 4.248 24.273.893 36.005-3.221 11.269-10.279 20.875-18.943 28.59-9.364 8.338-20.456 14.398-31.64 19.897a826.182 826.182 0 0 1-8.429 4.067c-.762.364-.097 1.499.663 1.136 11.793-5.635 23.704-11.319 34.217-19.187 9.276-6.942 17.545-15.656 22.464-26.272 5.202-11.225 6.268-23.989 4.112-36.101-2.107-11.836-7.394-22.915-14.468-32.563a106.51 106.51 0 0 0-11.681-13.365 96.741 96.741 0 0 0-14.245-11.64c-10.467-6.859-23.557-11.001-35.962-7.468-11.029 3.141-19.516 12-24.567 22.04-2.827 5.619-4.732 11.662-6.087 17.794a129.863 129.863 0 0 0-2.661 18.344 138.411 138.411 0 0 0 13.939 71.402 132.452 132.452 0 0 0 4.264 7.906.656.656 0 0 0 1.188-.174.658.658 0 0 0-.054-.49Z",
    fill: "#004438",
    fillOpacity: 0.05
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M200.3 227.786a134.785 134.785 0 0 1-13.792-33.288 137.579 137.579 0 0 1-4.607-35.754c.044-12.068 1.506-24.439 5.237-35.948 3.542-10.923 9.888-21.34 19.963-27.3a32.546 32.546 0 0 1 16.96-4.49c6.291.06 12.495 1.72 18.164 4.408 5.551 2.632 10.627 6.18 15.317 10.136a112.746 112.746 0 0 1 12.479 12.285c7.6 8.762 13.809 18.907 17.277 30.031 3.614 11.592 4.247 24.272.893 36.005-3.222 11.269-10.279 20.874-18.944 28.59-9.363 8.338-20.455 14.398-31.64 19.897-2.799 1.377-5.614 2.722-8.428 4.067-.763.364-.097 1.499.662 1.136 11.794-5.635 23.704-11.319 34.218-19.187 9.276-6.942 17.544-15.657 22.464-26.272 5.202-11.226 6.268-23.989 4.111-36.101-2.107-11.837-7.393-22.915-14.468-32.563a106.432 106.432 0 0 0-11.68-13.365 96.67 96.67 0 0 0-14.245-11.64c-10.468-6.86-23.558-11.002-35.963-7.468-11.028 3.14-19.516 12-24.566 22.039-2.827 5.62-4.732 11.663-6.088 17.795a130.133 130.133 0 0 0-2.661 18.344 138.424 138.424 0 0 0 13.94 71.402 131.619 131.619 0 0 0 4.264 7.906.66.66 0 0 0 .887.217.657.657 0 0 0 .246-.882Z",
    fill: "#004438",
    fillOpacity: 0.05
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M80.782 203.12a5.503 5.503 0 0 1 .257-6.687 5.478 5.478 0 0 1 1.877-1.456l15.175-47.637 10.569 5.504-18.24 45.095a5.534 5.534 0 0 1 .043 3.922 5.518 5.518 0 0 1-2.566 2.96 5.495 5.495 0 0 1-7.115-1.701Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M93.182 153.927a2.462 2.462 0 0 1 .012-2.05l5.197-11.203a6.837 6.837 0 0 1 3.277-4.062 6.802 6.802 0 0 1 5.18-.557 6.82 6.82 0 0 1 4.061 3.273 6.848 6.848 0 0 1 .571 5.192l-1.737 12.273a2.461 2.461 0 0 1-3.129 2.014l-11.89-3.532a2.44 2.44 0 0 1-1.542-1.348Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M137.021 155.818c-3.612 9.481-2.689 19.425 1.759 29.73h-31.509c1.266-7.332.752-14.146-3.939-19.743l33.689-9.987Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m100.145 138.395 9.325-6.799 15.259-4.25 12.717 2.55.747 7.045a85.296 85.296 0 0 1-1.171 25.677l-33.062 7.649-3.391-5.95s-7.63-7.649-1.696-16.148l1.272-9.774Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M181.138 90.836a5.514 5.514 0 0 1-.801 4.576 5.47 5.47 0 0 1-4.014 2.322l-30.698 39.415-8.012-8.834 32.694-35.967a5.529 5.529 0 0 1 1.316-3.693 5.5 5.5 0 0 1 7.243-1.012 5.518 5.518 0 0 1 2.272 3.193Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M152.511 132.675a2.463 2.463 0 0 1-.719 1.919l-8.748 8.704a6.81 6.81 0 0 1-9.529 1.397 6.85 6.85 0 0 1-1.419-9.551l5.87-10.909a2.466 2.466 0 0 1 1.633-1.235 2.46 2.46 0 0 1 1.999.432l9.934 7.444a2.461 2.461 0 0 1 .979 1.799Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M100.188 314.509h4.829l2.297-18.671h-7.126v18.671Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m98.552 312.121 7.633-.457v3.279l7.257 5.024a2.053 2.053 0 0 1 .05 3.335 2.04 2.04 0 0 1-1.211.399h-9.087l-1.566-3.243-.612 3.243H97.59l.962-11.58Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M134.321 314.509h4.829l2.297-18.671h-7.127l.001 18.671Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m132.685 312.121 7.633-.457v3.279l7.257 5.024a2.053 2.053 0 0 1 .05 3.335 2.041 2.041 0 0 1-1.211.399h-9.087l-1.567-3.243-.611 3.243h-3.426l.962-11.58ZM147.149 209.894v9.521l-.927 11.631s-.294 10.157-.648 18.169c-.214 4.87-.455 8.946-.665 9.472-.258.645-.197 2.405-.048 4.252.175 2.136.464 4.392.512 5.146.092 1.409-.652 7.459-.652 7.459s-.832 15.172-2.04 16.383c-1.208 1.211 0 4.655 0 4.655-5.663 4.185-12.814-.93-12.814-.93 1.58-2.523-.927-19.744-.927-19.744s-.368-5.879-1.112-7.459c-.744-1.579-.932-11.447-.932-11.447v-14.614s-1.952-2.992-2.227-4.388c-.276-1.395 0-6.326 0-6.326l-2.04-6.889-1.396 5.397s-3.615 15.08-4.267 16.94c-.652 1.86.368 3.725.368 3.725s.932 2.869 0 4.185a9.46 9.46 0 0 0-1.313 2.703s-.477 5.493-1.313 7.459c-.836 1.965-1.575 4.387-1.575 4.387s.197 3.712-.639 4.55c-.836.838-1.112 5.028-1.112 5.028s.184 4.743-.932 6.419c-1.116 1.676-1.116 11.17-1.116 11.17a12.968 12.968 0 0 1-13.076.558s1.103-1.036.267-5.862c-.836-4.826.6-17.967.6-17.967s-.184-3.334.743-4.826c.928-1.492-.468-4.374-.096-5.677s1.488-8.38 1.488-8.38-.464-17.405-.464-18.335a12.18 12.18 0 0 0-1.313-4.748c-.836-1.487 0-12.285 0-12.285s1.97-5.58 1.313-6.791c-.657-1.211.438-3.352.438-3.352s-1.02-2.514 0-2.979c1.019-.465 1.208-2.326 1.208-2.326l.708-9.029s.267-4.098 1.116-4.282c.849-.185.477-1.764 1.313-2.883a7.872 7.872 0 0 0 .832-2.422c.118-.517.227-1.057.319-1.575.263-1.404.425-2.615.425-2.615 5.479 4.563 34.288 1.365 34.318 1.365 1.83.399 4.005 6.765 5.576 12.315a56.14 56.14 0 0 1 2.1 15.242Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M126.196 115.366c2.1-6.926-1.798-14.246-8.705-16.352-6.908-2.105-14.21 1.802-16.31 8.728-2.1 6.925 1.798 14.246 8.705 16.351 6.908 2.105 14.21-1.802 16.31-8.727Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m98.911 113.838 5.062-1.056.932-6.735 1.748 6.176 2.42-.505.543-3.929 1.02 3.603 17.977-3.75a13.886 13.886 0 0 0-5.961-8.777 13.817 13.817 0 0 0-10.406-1.98l-2.605.543c-3.594.75-6.743 2.9-8.755 5.977a13.906 13.906 0 0 0-1.975 10.433Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m150.697 15.29-.033.064a28.24 28.24 0 0 0-20.999-1.079 28.327 28.327 0 0 0-15.948 13.739 28.442 28.442 0 0 0-2.098 20.975 28.368 28.368 0 0 0 12.91 16.64l-.033.063 50.273 26.27 26.202-50.403a28.482 28.482 0 0 0-3.396-31.41 28.371 28.371 0 0 0-8.627-6.95 28.291 28.291 0 0 0-31.327 3.436 28.428 28.428 0 0 0-6.924 8.655ZM195.489 304.513l-.008.016a7.136 7.136 0 0 0-5.308-.273 7.16 7.16 0 0 0-4.031 3.472 7.19 7.19 0 0 0-.53 5.302 7.172 7.172 0 0 0 3.263 4.206l-.008.016 12.706 6.639 6.623-12.739a7.193 7.193 0 0 0 .485-5.479 7.186 7.186 0 0 0-3.524-4.217 7.155 7.155 0 0 0-9.668 3.057Z",
    fill: "#B9EAFF"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M26.929 142.987v.072a28.277 28.277 0 0 0-19.12 8.774A28.418 28.418 0 0 0 0 171.405a28.418 28.418 0 0 0 7.81 19.573 28.277 28.277 0 0 0 19.119 8.774v.072H83.62v-56.837a28.484 28.484 0 0 0-2.15-10.884 28.427 28.427 0 0 0-6.143-9.229 28.355 28.355 0 0 0-9.2-6.167 28.281 28.281 0 0 0-21.707 0 28.354 28.354 0 0 0-9.2 6.167 28.427 28.427 0 0 0-6.143 9.229 28.484 28.484 0 0 0-2.15 10.884Z",
    fill: "#3763e9"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M291.134 324.59H7.861a.52.52 0 0 1-.369-.891.52.52 0 0 1 .369-.153h283.273a.522.522 0 0 1 0 1.044Z",
    fill: "#CACACA"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M246.033 196.681a24.98 24.98 0 0 0 15.841-5.797 24.36 24.36 0 0 0 8.387-15.044c.512-3.32.347-6.71-.485-9.964a.657.657 0 0 0-1.266.35 23.726 23.726 0 0 1-1.783 16.467 23.38 23.38 0 0 1-8.578 9.241 23.308 23.308 0 0 1-12.116 3.431.658.658 0 0 0 0 1.316Z",
    fill: "#004438",
    fillOpacity: 0.05
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M144.658 25.72c-3.736-3.555-9.634-3.545-13.948-1.07-4.841 2.777-7.036 8.515-6.925 13.904.125 6.064 3.083 11.555 6.901 16.103a64.03 64.03 0 0 0 14.06 12.183 70.552 70.552 0 0 0 19.063 8.726.656.656 0 0 0 .729-.956.657.657 0 0 0-.38-.313 68.883 68.883 0 0 1-30.152-17.936c-3.971-4.077-7.499-8.977-8.585-14.68-.958-5.037.101-10.885 3.995-14.472 3.785-3.488 10.41-4.273 14.314-.558.612.583 1.542-.346.928-.93ZM25.957 156.832c-5.045-.629-9.784 2.929-11.75 7.423-2.203 5.04-.717 10.849 2.48 15.109 3.52 4.69 8.853 7.425 14.427 8.876 5.984 1.559 12.336 1.979 18.495 1.691a70.572 70.572 0 0 0 21.302-4.341c.785-.292.446-1.565-.349-1.269-11.378 4.236-24.045 5.572-36.01 3.336-5.35-1-10.796-2.907-14.782-6.765-3.611-3.496-6.166-8.79-5.08-13.902 1.08-5.08 5.898-9.511 11.267-8.842.837.105.83-1.212 0-1.316Z",
    fill: "#fff"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M109.902 92.359c1.22-4.891-1.144-10.137-4.804-13.595-3.659-3.458-8.435-5.445-13.162-7.165-3.77-1.373-8.185-2.566-11.597-.453-2.741 1.698-3.93 4.997-5.498 7.82a25.58 25.58 0 0 1-13.573 11.611 25.502 25.502 0 0 1-17.842-.118c2.023 5.888 8.992 8.769 15.192 8.369 6.2-.4 11.925-3.263 17.7-5.558 5.775-2.295 12.2-4.069 18.135-2.23 2.505.775 4.784 2.16 7.264 3.012 2.481.852 5.383 1.106 7.594-.308",
    fill: "#2F2E41"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m196.735 271.493-4.226-7.457a.652.652 0 0 0-.887-.217.658.658 0 0 0-.246.881l4.226 7.458a.66.66 0 0 0 .887.217.663.663 0 0 0 .246-.882Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "donationImg02_svg__a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h300v324.59H0z"
  })))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgDonationImg02);

/***/ }),

/***/ 61344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ donation_DonationForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
;// CONCATENATED MODULE: ./public/images/donationImg01.svg
var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDonationImg01 = function SvgDonationImg01(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 208,
    height: 200,
    viewBox: "0 0 314 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#donationImg01_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M282.771 291.609c1.189.074 1.846-1.401.947-2.261l-.09-.356.036-.085c1.202-2.865 5.277-2.845 6.47.024 1.058 2.546 2.405 5.096 2.737 7.788a10.346 10.346 0 0 1-.182 3.565 41.529 41.529 0 0 0 3.784-17.261c0-1.493-.082-2.986-.249-4.475a41.464 41.464 0 0 0-.572-3.628c-1.328-6.484-4.201-12.66-8.346-17.818-1.993-1.088-3.654-2.789-4.658-4.828-.361-.735-.643-1.526-.777-2.332.227.029.855-3.421.684-3.632.316-.479.882-.717 1.227-1.185 1.716-2.325 4.081-1.919 5.316 1.24 2.637 1.33 2.663 3.535 1.044 5.656-1.029 1.35-1.171 3.176-2.074 4.62.093.119.19.234.283.353a42.288 42.288 0 0 1 4.42 6.997c-.351-2.741.168-6.042 1.052-8.171 1.006-2.424 2.892-4.467 4.552-6.563 1.995-2.518 6.086-1.419 6.437 1.773l.01.093c-.246.139-.488.286-.724.442-1.347.89-.881 2.975.714 3.221l.036.006a17.595 17.595 0 0 1-.464 2.633c2.13 8.231-2.469 11.229-9.037 11.364-.145.074-.287.148-.432.219a41.93 41.93 0 0 1 1.592 5.737c.353 1.72.598 3.458.736 5.203a40.911 40.911 0 0 1-.03 6.614l.011-.078c.472-2.421 1.788-4.683 3.699-6.25 2.846-2.336 6.868-3.196 9.939-5.073 1.478-.904 3.372.264 3.114 1.976l-.013.082a11.846 11.846 0 0 0-2.058 1.085c-1.347.89-.882 2.975.714 3.221l.036.005.074.012a17.616 17.616 0 0 1-3.245 5.076c-1.332 7.186-7.054 7.867-13.174 5.775h-.004a43.119 43.119 0 0 1-2.904 8.467h-10.371c-.037-.115-.071-.234-.104-.349.959.059 1.925.004 2.87-.171-.77-.943-1.539-1.894-2.309-2.837a.796.796 0 0 1-.048-.056c-.39-.483-.785-.962-1.175-1.444v-.001a17.268 17.268 0 0 1 .506-4.393Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M91.945 300.316c0 .38.305.685.685.685h220.604a.683.683 0 0 0 .684-.685.682.682 0 0 0-.684-.684H92.63a.683.683 0 0 0-.685.684Z",
    fill: "#CCC"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M125.422 300.709H23.88c-12.381 0-22.454-10.063-22.454-22.432V60.275c0-12.368 10.073-22.431 22.454-22.431h101.542c12.381 0 22.454 10.063 22.454 22.431v218.002c0 12.369-10.073 22.432-22.454 22.432Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M147.872 118.032a.95.95 0 0 0-.95.949v30.367a.95.95 0 0 0 1.9 0v-30.367a.95.95 0 0 0-.95-.949Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M145.738 60.276v217.998c0 10.766-8.388 19.572-18.994 20.256h-.005c-.157.009-.313.019-.475.023-.28.015-.56.019-.845.019 0 0-1.045-.075-2.954-.218-1.929-.142-4.736-.356-8.236-.636a1557.894 1557.894 0 0 1-10.948-.901c-1.093-.09-2.223-.19-3.377-.29-5.9-.507-12.506-1.1-19.474-1.774a524.51 524.51 0 0 1-3.562-.342c-.313-.033-.631-.061-.95-.095-4.968-.488-72.356-13.499-72.356-16.042V60.276c0-11.212 9.096-20.298 20.32-20.298h12.13c1.938 0 3.495 1.509 3.662 3.44.014.128.028.256.052.384.352 1.94 2.133 3.293 4.108 3.293h61.632c1.976 0 3.757-1.352 4.108-3.293.024-.128.038-.256.052-.384.167-1.931 1.724-3.44 3.662-3.44h12.131c11.223 0 20.319 9.086 20.319 20.298Z",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M.95 95.257a.95.95 0 0 0-.95.95v7.591a.95.95 0 0 0 1.9 0v-7.592a.95.95 0 0 0-.95-.949ZM.95 118.032a.95.95 0 0 0-.95.949v14.709a.95.95 0 0 0 1.9 0v-14.709a.95.95 0 0 0-.95-.949ZM.95 138.909a.95.95 0 0 0-.95.949v14.709a.95.95 0 0 0 1.9 0v-14.709a.95.95 0 0 0-.95-.949Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.68 43.3H17.516a.179.179 0 0 0-.18.179v2.016c0 .098.08.178.18.178H35.68c.099 0 .178-.08.178-.178v-2.016a.178.178 0 0 0-.178-.179ZM116.29 45.672a1.899 1.899 0 1 0 .003-3.797 1.899 1.899 0 0 0-.003 3.797ZM121.513 45.672a1.9 1.9 0 1 0 .002-3.793 1.9 1.9 0 0 0-.002 3.793ZM126.74 45.672a1.9 1.9 0 1 0 .002-3.793 1.9 1.9 0 0 0-.002 3.793ZM114.7 171.639H34.122a2.304 2.304 0 0 1-2.302-2.3c0-1.268 1.033-2.3 2.303-2.3H114.7a2.304 2.304 0 0 1 2.302 2.3c0 1.268-1.033 2.3-2.302 2.3Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M74.702 260.76c18.437 0 33.382-14.931 33.382-33.348 0-18.418-14.945-33.349-33.382-33.349-18.436 0-33.382 14.931-33.382 33.349 0 18.417 14.946 33.348 33.382 33.348Z",
    fill: "#3763e9"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M80.006 216.523c-2.817.115-6.002.309-8.085 2.468-1.809 1.876-2.205 4.66-.37 6.664 1.839 2.008 4.698 2.28 6.819 3.846 2.49 1.84 2.125 5.479-.285 7.223-2.84 2.056-6.509 1.097-9.106-.859-.665-.501-1.311.622-.653 1.117 2.327 1.753 5.363 2.729 8.24 1.89 2.597-.757 4.61-2.872 4.814-5.623.098-1.313-.276-2.646-1.093-3.683-.863-1.094-2.106-1.767-3.362-2.315-2.162-.943-5.886-2.164-5.257-5.235.762-3.722 5.297-4.075 8.338-4.2.83-.034.835-1.328 0-1.293Z",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m74.78 214.763-.124 28.4c-.003.832 1.292.833 1.295 0l.124-28.4c.004-.833-1.29-.834-1.295 0ZM251.567 0H86.982c-6.037 0-10.947 4.905-10.947 10.936v112.672c0 6.032 4.91 10.936 10.947 10.936h164.585c6.038 0 10.947-4.904 10.947-10.936V10.936C262.514 4.905 257.605 0 251.567 0Z",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M168.515 66.993c10.172 0 18.418-8.237 18.418-18.4 0-10.16-8.246-18.398-18.418-18.398-10.171 0-18.417 8.237-18.417 18.399 0 10.161 8.246 18.4 18.417 18.4Z",
    fill: "#3763e9"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M172.007 40.384c-2.279.094-4.846.238-6.57 1.933-1.429 1.404-1.928 3.59-.616 5.243 1.382 1.74 3.681 2.07 5.485 3.183 1.121.691 1.864 1.738 1.888 3.084.023 1.26-.559 2.437-1.532 3.227-2.388 1.938-5.643 1.135-7.902-.559-.444-.333-.875.415-.436.745 1.871 1.403 4.279 2.218 6.607 1.614 2.143-.556 3.868-2.24 4.101-4.49.244-2.37-1.314-3.985-3.335-4.911-1.848-.847-5.088-1.75-4.782-4.38.388-3.344 4.486-3.72 7.092-3.827.554-.022.557-.885 0-.862Z",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m168.049 38.82-.104 23.664c-.002.555.861.556.864 0l.103-23.665c.003-.555-.861-.556-.863 0Z",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M251.567 0H86.982c-6.037 0-10.947 4.905-10.947 10.936v112.672c0 6.032 4.91 10.936 10.947 10.936h164.585c6.038 0 10.947-4.904 10.947-10.936V10.936C262.514 4.905 257.605 0 251.567 0Zm9.796 123.608c0 5.399-4.392 9.786-9.796 9.786H86.982c-5.404 0-9.796-4.387-9.796-9.786V10.936c0-5.399 4.392-9.786 9.796-9.786h164.585c5.404 0 9.796 4.387 9.796 9.786v112.672Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M150.299 11.125h-16.15a1.475 1.475 0 0 0 0 2.95h16.15a1.476 1.476 0 0 0 0-2.95ZM177.35 11.125H161.2a1.475 1.475 0 0 0 0 2.95h16.15a1.475 1.475 0 0 0 0-2.95ZM204.401 11.125h-16.15a1.476 1.476 0 0 0 0 2.95h16.15a1.475 1.475 0 0 0 0-2.95Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M231.035 77.343H107.51c-5.14 0-9.319 4.174-9.319 9.309v8.406c0 5.134 4.179 9.309 9.319 9.309h123.525c5.139 0 9.318-4.175 9.318-9.31v-8.405c0-5.135-4.179-9.31-9.318-9.31Z",
    fill: "#3763e9"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m42.12 121.603-4.737-2.242c1.943 2.709 3.617 6.939 4.513 10.305 1.517-3.135 3.964-6.972 6.385-9.264l-5.006 1.287c3.084-15.104 14.687-25.946 27.974-25.946v-1.15c-13.878 0-25.98 11.297-29.13 27.01Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M63.922 144.616H33.994a2.304 2.304 0 0 1-2.303-2.3c0-1.268 1.033-2.3 2.303-2.3h29.928a2.304 2.304 0 0 1 2.303 2.3c0 1.268-1.033 2.3-2.303 2.3Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m263.017 137.125-.302 23.482-5.848 20.932-4.676-1.742 2.076-19.187-.273-25.964 9.023 2.479Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M256.847 184.915c.548-3.009-.457-5.713-2.246-6.039-1.789-.325-3.684 1.851-4.233 4.861-.548 3.01.457 5.714 2.246 6.039 1.789.326 3.684-1.851 4.233-4.861Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M255.921 109.167s10.018.138 10.01 5.454c-.005 3.002-.65 30.257-2.446 46.815-1.385 12.768-4.029 16.099-4.029 16.099l-6.331-14.374 2.796-53.994Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M255.66 157.141h-33.836c2.836-6.322 4.58-12.343 1.854-17.132l31.982-1.852c-1.599 6.465-1.794 12.81 0 18.984Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m251.489 101.114-13.442-.926-5.562 6.945-2.82.512a8.587 8.587 0 0 0-7.047 8.824l1.097 24.903 32.127 2.341 7.698-32.43-9.27-3.687-2.781-6.482Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M169.519 108.628c.954.857 1.635 1.858 1.994 2.829l9.601 7.591-3.749 4.458-9.336-8.18c-1.004-.255-2.073-.826-3.026-1.683-2.179-1.958-2.934-4.668-1.687-6.053 1.247-1.385 4.025-.92 6.203 1.038Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m237.399 115.018-36.787 24.816-26.37-18.333 3.959-7.164 20.755 12.05 19.14-14.682c6.815-6.396 15.357-5.156 19.303 3.313Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M243.972 98.108c5.507 0 9.972-4.46 9.972-9.962 0-5.501-4.465-9.962-9.972-9.962S234 82.644 234 88.147c0 5.501 4.465 9.961 9.972 9.961Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M257.525 85.699v1.932l-11.246-3.162-8.432 1.765a8.794 8.794 0 0 0-1.111-3.657c.44 1.789.49 3.173.023 3.887l-1.134.235a2.298 2.298 0 0 0-1.007-1.201c-.046-.029-.104-.052-.156-.035-.08.029-.086.132-.086.213.012.425.023.85.04 1.276l-3.257.679v-1.932c-3.125-7.025 5.112-13.104 13.186-13.167 3.643-.028 6.935 1.472 9.324 3.852a13.138 13.138 0 0 1 3.856 9.315Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m263.854 108.352-.849-.07c.061-.278.121-.552.176-.829.471-2.328-.565-5.292-.641-7.53-.4 2.364.284 5.272-.424 7.516-.079.249-3.152 1.858-3.236 2.104-3.401-1.242-6.943-5.212-10.953-2.894-2.372 1.372-5.079.771-7.772.143-.667-.156-.759-3.444-1.419-3.573-1.182-.232-2.917 2.758-4.029 2.874l4.604-17.824c0-9.696-.899-19.87 11.396-16.44 3.093.861 6.153 1.537 8.436 4.087 2.282 2.553 3.907 6.121 4.483 10.185.347 2.45 2.513 10.774.228 22.251Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m255.912 287.593-5.489.129-3.06-24.634 8.1-.192.449 24.697Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M237.082 299.032c0 .927.658 1.678 1.47 1.678h10.895s1.072-4.306 5.443-6.159l.302 6.159h5.62l-.681-9.903s1.503-5.297-1.619-8.005c-3.122-2.708-.593-2.331-.593-2.331l-1.229-6.129-8.492.998-.063 9.62-4.121 9.55-6.046 2.983c-.538.265-.886.87-.886 1.539Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m239.216 283.577-5.277 1.516-9.216-23.052 7.786-2.239 6.707 23.775Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M223.906 299.416c.236.896 1.063 1.455 1.848 1.249l10.538-2.761s-.057-4.437 3.701-7.337l1.856 5.88 5.436-1.425-3.174-9.405s.109-5.505-3.599-7.333c-3.708-1.828-1.166-2.105-1.166-2.105l-2.745-5.616-7.961 3.118 2.383 9.321-1.561 10.282-5.089 4.418c-.453.393-.637 1.067-.467 1.714ZM252.549 155.685l3.454 1.15c5.399 9.962 7.688 23.191 7.385 39.144l-6.134 71.648h-10.036l-7.344-79.819-12.95 29.959 9.475 49.86-9.475.965-19.084-51.846 13.29-60.259 31.419-.802Z",
    fill: "#2F2E41"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "donationImg01_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h314v301H0z"
  })))));
};
/* harmony default export */ var donationImg01 = (SvgDonationImg01);
// EXTERNAL MODULE: ./public/images/donationImg02.svg
var donationImg02 = __webpack_require__(42486);
;// CONCATENATED MODULE: ./public/images/Stripe.svg
var Stripe_defs, _path, _path2;
function Stripe_extends() { Stripe_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Stripe_extends.apply(this, arguments); }

var SvgStripe = function SvgStripe(props) {
  return /*#__PURE__*/react.createElement("svg", Stripe_extends({
    id: "Stripe_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 34"
  }, props), Stripe_defs || (Stripe_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null, ".Stripe_svg__cls-1{fill:#635bff}"))), _path || (_path = /*#__PURE__*/react.createElement("path", {
    className: "Stripe_svg__cls-1",
    d: "M146 0H3.73A3.73 3.73 0 0 0 0 3.73v26.54A3.73 3.73 0 0 0 3.73 34H146a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4Zm3 30a3 3 0 0 1-3 3H3.73A2.74 2.74 0 0 1 1 30.27V3.73A2.74 2.74 0 0 1 3.73 1H146a3 3 0 0 1 3 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    className: "Stripe_svg__cls-1",
    d: "M17.07 11.24h-4.3V22h1.92v-4.16h2.38c2.4 0 3.9-1.16 3.9-3.3s-1.5-3.3-3.9-3.3Zm-.1 5h-2.28v-3.3H17c1.38 0 2.11.59 2.11 1.65s-.76 1.6-2.11 1.6ZM25.1 14a3.77 3.77 0 0 0-3.8 4.09 3.81 3.81 0 1 0 7.59 0A3.76 3.76 0 0 0 25.1 14Zm0 6.67c-1.22 0-2-1-2-2.58s.76-2.58 2-2.58 2 1 2 2.58-.79 2.57-2 2.57ZM36.78 19.35l-1.41-5.22h-1.48l-1.4 5.22-1.42-5.22h-1.85l2.37 7.88h1.56l1.44-5.16 1.44 5.16h1.56l2.37-7.88h-1.78l-1.4 5.22zM44 14a3.83 3.83 0 0 0-3.75 4.09 3.79 3.79 0 0 0 3.83 4.09A3.47 3.47 0 0 0 47.49 20L46 19.38a1.78 1.78 0 0 1-1.83 1.26A2.12 2.12 0 0 1 42 18.47h5.52v-.6C47.54 15.71 46.32 14 44 14Zm-1.93 3.13A1.92 1.92 0 0 1 44 15.5a1.56 1.56 0 0 1 1.69 1.62ZM50.69 15.3v-1.17h-1.8V22h1.8v-4.13a1.89 1.89 0 0 1 2-2 4.68 4.68 0 0 1 .66 0v-1.8h-.51a2.29 2.29 0 0 0-2.15 1.23ZM57.48 14a3.83 3.83 0 0 0-3.75 4.09 3.79 3.79 0 0 0 3.83 4.09A3.47 3.47 0 0 0 60.93 20l-1.54-.59a1.78 1.78 0 0 1-1.83 1.26 2.12 2.12 0 0 1-2.1-2.17H61v-.6c0-2.19-1.24-3.9-3.52-3.9Zm-1.93 3.13a1.92 1.92 0 0 1 1.92-1.62 1.56 1.56 0 0 1 1.69 1.62ZM67.56 15a2.85 2.85 0 0 0-2.26-1c-2.21 0-3.47 1.85-3.47 4.09s1.26 4.09 3.47 4.09a2.82 2.82 0 0 0 2.26-1V22h1.8V11.24h-1.8Zm0 3.35a2 2 0 0 1-2 2.28c-1.31 0-2-1-2-2.52s.7-2.52 2-2.52c1.11 0 2 .81 2 2.29ZM79.31 14A2.88 2.88 0 0 0 77 15v-3.76h-1.8V22H77v-.83a2.86 2.86 0 0 0 2.27 1c2.2 0 3.46-1.86 3.46-4.09S81.51 14 79.31 14ZM79 20.6a2 2 0 0 1-2-2.28v-.47c0-1.48.84-2.29 2-2.29 1.3 0 2 1 2 2.52s-.75 2.52-2 2.52ZM86.93 19.66 85 14.13h-1.9l2.9 7.59-.3.74a1 1 0 0 1-1.14.79 4.12 4.12 0 0 1-.6 0v1.51a4.62 4.62 0 0 0 .73.05 2.67 2.67 0 0 0 2.78-2l3.24-8.62h-1.89ZM125 12.43a3 3 0 0 0-2.13.87l-.14-.69h-2.39v12.92l2.72-.59v-3.13a3 3 0 0 0 1.93.7c1.94 0 3.72-1.59 3.72-5.11 0-3.22-1.8-4.97-3.71-4.97Zm-.65 7.63a1.61 1.61 0 0 1-1.28-.52v-4.11a1.64 1.64 0 0 1 1.3-.55c1 0 1.68 1.13 1.68 2.58s-.69 2.6-1.7 2.6ZM133.73 12.43c-2.62 0-4.21 2.26-4.21 5.11 0 3.37 1.88 5.08 4.56 5.08a6.12 6.12 0 0 0 3-.73v-2.25a5.79 5.79 0 0 1-2.7.62c-1.08 0-2-.39-2.14-1.7h5.38v-1c.09-2.87-1.27-5.13-3.89-5.13Zm-1.47 4.07c0-1.26.77-1.79 1.45-1.79s1.4.53 1.4 1.79ZM113 13.36l-.17-.82h-2.32v9.71h2.68v-6.58a1.87 1.87 0 0 1 2.05-.58v-2.55a1.8 1.8 0 0 0-2.24.82ZM99.46 15.46c0-.44.36-.61.93-.61a5.9 5.9 0 0 1 2.7.72v-2.63a7 7 0 0 0-2.7-.51c-2.21 0-3.68 1.18-3.68 3.16 0 3.1 4.14 2.6 4.14 3.93 0 .52-.44.69-1 .69a6.78 6.78 0 0 1-3-.9V22a7.38 7.38 0 0 0 3 .64c2.26 0 3.82-1.15 3.82-3.16-.05-3.36-4.21-2.76-4.21-4.02ZM107.28 10.24l-2.65.58v8.93a2.77 2.77 0 0 0 2.82 2.87 4.16 4.16 0 0 0 1.91-.37V20c-.35.15-2.06.66-2.06-1v-4h2.06v-2.34h-2.06ZM116.25 11.7l2.73-.57V8.97l-2.73.57v2.16zM116.25 12.61h2.73v9.64h-2.73z"
  })));
};
/* harmony default export */ var Stripe = (SvgStripe);
;// CONCATENATED MODULE: ./public/images/GiftAid.png
/* harmony default export */ var GiftAid = ({"src":"https://images-prod.forumm.to/3031/_next/static/media/GiftAid.4c4b5d65.png","height":346,"width":800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAQAAAAEwYbDAAAAMUlEQVR42mMAAUFJQRlRZn4RYRkhfgYGFgFLQWtBSyEzAW1hbREBhigJSVkGdgY4AABaxQNaLqYhOgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});
// EXTERNAL MODULE: ./node_modules/@stripe/react-stripe-js/dist/react-stripe.umd.js
var react_stripe_umd = __webpack_require__(86664);
// EXTERNAL MODULE: ./components/inputs/TextInput.tsx
var TextInput = __webpack_require__(39618);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./graphql/__generated/graphql.ts
var graphql = __webpack_require__(68240);
// EXTERNAL MODULE: ./components/inputs/Button.tsx
var Button = __webpack_require__(11390);
// EXTERNAL MODULE: ./components/inputs/ItemPicker.tsx
var ItemPicker = __webpack_require__(94745);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./components/inputs/ToggleInput.tsx
var ToggleInput = __webpack_require__(20970);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/events/eventDonationCreatePaymentIntent.ts

const EVENT_DONATON_CREATE_PAYMENT_INTENT = (0,_generated/* graphql */.B)("\n  mutation eventDonationCreatePaymentIntent(\n    $input: DonationPaymentIntentInput!\n  ) {\n    eventDonationCreatePaymentIntent(input: $input) {\n      clientSecret\n      nextAction\n      error\n    }\n  }\n");

// EXTERNAL MODULE: ./components/base/Modal.tsx
var Modal = __webpack_require__(18860);
// EXTERNAL MODULE: ./libs/useTheme.ts + 1 modules
var useTheme = __webpack_require__(5779);
// EXTERNAL MODULE: ./libs/useStatistics.ts
var useStatistics = __webpack_require__(23638);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./components/inputs/DropdownInput.tsx
var DropdownInput = __webpack_require__(61993);
// EXTERNAL MODULE: ./components/inputs/PriceInput.tsx
var PriceInput = __webpack_require__(84456);
// EXTERNAL MODULE: ./components/inputs/TextAreaInput.tsx
var TextAreaInput = __webpack_require__(33923);
// EXTERNAL MODULE: ./libs/currencies.ts
var currencies = __webpack_require__(30530);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./node_modules/react-share/dist/index.js
var dist = __webpack_require__(68258);
// EXTERNAL MODULE: ./libs/Utility/util.ts + 2 modules
var util = __webpack_require__(52229);
// EXTERNAL MODULE: ./components/base/RichTextDisplay.tsx
var RichTextDisplay = __webpack_require__(25536);
// EXTERNAL MODULE: ./libs/Stripe/util.ts + 1 modules
var Stripe_util = __webpack_require__(16458);
// EXTERNAL MODULE: ./libs/Utility/validation.ts
var validation = __webpack_require__(49532);
// EXTERNAL MODULE: ./libs/Utility/register.util.ts
var register_util = __webpack_require__(49981);
;// CONCATENATED MODULE: ./components/donation/DonationForm.tsx






































const DatePicker = (react_datepicker_min_default());
const ModalFlow = [
    {
        title: "Programme",
        step: 0
    },
    {
        title: "Donation",
        step: 1
    },
    {
        title: "Payment",
        step: 2
    },
    {
        title: "Gift Aid",
        step: 3
    },
    {
        title: "Wall",
        step: 4
    },
    {
        title: "Details",
        step: 5
    },
    {
        title: "",
        step: 6
    }
];
const PaymentMethods = {
    APPLE_PAY: "Apple pay",
    CARD: "Card",
    DIRECT_DEBIT: "Direct Debit",
    GOOGLE_PAY: "Google pay"
};
const SKIP_GITFT_AID_EVENT_LIST = [
    "launch-foods-foundation",
    "sussex-hardship-appeal-us",
    "americanfriends"
];
const CUSTOM_GIFT_AID_COPY = [
    {
        eventId: "c52572c0-4a42-4ba1-b834-8d5500740dd4",
        step: "sussex"
    },
    // Hardship Appeal
    {
        eventId: "d9232843-4c2d-4f7f-b2d8-ab89499cd9d1",
        step: "sussex"
    },
    // Hardship Grant
    {
        eventId: "cd54965b-4538-44bf-b177-1f0837706cee",
        step: "sussex"
    },
    // Sussex Fund
    {
        eventId: "b9504ce6-f68e-4f31-a6cf-df99d55a113e",
        step: "sussex"
    }
];
const IS_ONE_TIME_PAY = "One-time card";
const IS_REGULAR_DIRECT_DEBIT = "Regular Direct Debit";
const LOCATIONS = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo",
    "Democratic Republic of the Congo",
    "Costa Rica",
    "C\xf4te d'Ivoire",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czechia",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Timor-Leste",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "North Korea",
    "South Korea",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe"
];
const DonationForm = (param)=>{
    let { organisationCurrency , platformFee , feeAbsorption , eventDetails , programs , eventId , isOpen , setIsOpen , refetchDonations , initialValue , formCTA , onComplete =()=>{} , disablePayment =false , showInline =false  } = param;
    const statisticId = (0,useStatistics/* default */.Z)();
    var ref;
    const configSkipGiftAidStep = SKIP_GITFT_AID_EVENT_LIST.includes((ref = eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.donationUrl) !== null && ref !== void 0 ? ref : "");
    const [paymentError, setPaymentError] = (0,react.useState)("");
    const [loading, setLoading] = (0,react.useState)(false);
    const [disable, setDisable] = (0,react.useState)(false);
    const [payment3DSUrl, setPayment3DSUrl] = (0,react.useState)();
    const [isMobile, setIsMobile] = (0,react.useState)(false);
    const [giftAidStep, setGiftAidStep] = (0,react.useState)(1);
    const [altPaymentEnabled, setAltPaymentEnabled] = (0,react.useState)(false);
    const { theme , StaticColours  } = (0,useTheme/* useTheme */.Fg)();
    var ref1;
    const onlyOneTimePayments = [
        "sussex-hardship-appeal-us"
    ].includes((ref1 = eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.donationUrl) !== null && ref1 !== void 0 ? ref1 : "");
    const selectionColour = theme.type === "DARK" ? StaticColours.v2.dark_light_blue : StaticColours.v2.light_blue;
    const [modalStage, setModalStage] = (0,react.useState)(ModalFlow[0]);
    const [validPaymentDetails, setValidPaymentDetails] = (0,react.useState)({
        number: false,
        mmaa: false,
        cvc: false
    });
    const [stripeCardCompleted, setStripeCardCompleted] = (0,react.useState)(false);
    const [paymentMethod, setPaymentMethod] = (0,react.useState)();
    const [paymentRequest, setPaymentRequest] = (0,react.useState)(null);
    var ref2, ref3;
    // const params = new URLSearchParams(window.location.search)
    // const programmeQuery = params.get('programme') ?? ''
    //
    // const programme = programs
    //   ?.find((p) => p.title.toUpperCase() === programmeQuery.toUpperCase())
    //   ?.title.toUpperCase()
    const initialState = {
        currency: organisationCurrency,
        amount: 100,
        donator: {
            dob: "",
            title: "",
            firstName: "",
            lastName: "",
            email: ""
        },
        message: "",
        donatedAt: moment_default()().toISOString(),
        program: (ref3 = (ref2 = initialValue === null || initialValue === void 0 ? void 0 : initialValue.selectedProgram) !== null && ref2 !== void 0 ? ref2 : programs === null || programs === void 0 ? void 0 : programs[0].title) !== null && ref3 !== void 0 ? ref3 : "",
        payment: {
            method: "CARD",
            isRecurring: false,
            coverPlatformFee: false,
            coverTrxFee: false,
            giftAid: false,
            giftAidConfirm: false,
            card_details: {
                number: "",
                exp_date: "",
                CVC: "",
                post_code: "",
                address: ""
            }
        },
        paymentType: graphql/* PaymentType.Card */.uG.Card,
        selectedRecurrency: "",
        homeAddress: undefined,
        addressCountry: "United Kingdom",
        visibility: "Name & amount",
        directDebit: {
            name: "",
            number: "",
            sort: "",
            confirmDirectDebit: false
        }
    };
    const [modalData, setModalData] = (0,react.useState)((0,lodash.cloneDeep)(initialState));
    const [isGooglePayEnabled, setIsGooglePayEnabled] = (0,react.useState)(false);
    const hasPrograms = !!programs && (programs === null || programs === void 0 ? void 0 : programs.length) > 0;
    (0,react.useEffect)(()=>{
        if (modalStage.step === 0) setModalStage(ModalFlow[!programs || (programs === null || programs === void 0 ? void 0 : programs.length) < 1 ? 1 : 0]);
        if (programs && programs.length > 0) {
            var ref, ref1, ref2;
            let targetProgram;
            let programme;
            const params = new URLSearchParams(window.location.search);
            const programmeQuery = params.get("p");
            // Temporary Hard-coded url handler for programmes
            if ((programmeQuery === null || programmeQuery === void 0 ? void 0 : programmeQuery.toLowerCase()) === "christmas-toy-appeal") {
                targetProgram = "Launch Foods Christmas Toy Appeal 2024";
            }
            // // Launch wanted the default program to be the xmas toy appeal
            // if (!programmeQuery) {
            //   if (eventDetails.donationUrl === 'launch-foods-foundation')
            //     targetProgram = 'Launch Foods Christmas Toy Appeal 2024'
            // }
            if (!!targetProgram) programme = programs === null || programs === void 0 ? void 0 : programs.find((p)=>{
                return p.title.toUpperCase() === (targetProgram === null || targetProgram === void 0 ? void 0 : targetProgram.toUpperCase());
            });
            var ref3, ref4;
            setModalData({
                ...modalData,
                program: (ref4 = (ref3 = programme === null || programme === void 0 ? void 0 : (ref = programme.title) === null || ref === void 0 ? void 0 : ref.toUpperCase()) !== null && ref3 !== void 0 ? ref3 : modalData === null || modalData === void 0 ? void 0 : modalData.program) !== null && ref4 !== void 0 ? ref4 : programs === null || programs === void 0 ? void 0 : (ref1 = programs[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.title) === null || ref2 === void 0 ? void 0 : ref2.toUpperCase()
            });
            if (!!programme && !!programmeQuery) setIsOpen === null || setIsOpen === void 0 ? void 0 : setIsOpen(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        programs
    ]);
    const stripe = (0,react_stripe_umd.useStripe)();
    const elements = (0,react_stripe_umd.useElements)();
    (0,react.useEffect)(()=>{
        setIsMobile(/iPhone|Android|iPod|Windows Phone|BlackBerry/i.test(navigator.userAgent) && !/iPad|Tablet/i.test(navigator.userAgent));
    }, []);
    (0,react.useEffect)(()=>{
        if (initialValue === null || initialValue === void 0 ? void 0 : initialValue.selectedProgram) {
            var ref, ref1;
            var _program, ref2, ref3;
            setModalData({
                ...modalData,
                program: (ref3 = (ref2 = (_program = modalData.program) !== null && _program !== void 0 ? _program : initialValue === null || initialValue === void 0 ? void 0 : initialValue.selectedProgram) !== null && ref2 !== void 0 ? ref2 : programs === null || programs === void 0 ? void 0 : (ref = programs[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase()) !== null && ref3 !== void 0 ? ref3 : ""
            });
        }
    }, [
        initialValue
    ]);
    const [eventDonationCreatePaymentIntent] = (0,useMutation/* useMutation */.D)(EVENT_DONATON_CREATE_PAYMENT_INTENT);
    const router = (0,next_router.useRouter)();
    const pageUrl = "https://".concat(window.location.hostname).concat(router.asPath);
    const returnUrl = "".concat(window.location.hostname.includes("localhost") ? "http://localhost:3000" : "https://".concat(window.location.hostname), "/verify-payment");
    (0,react.useEffect)(()=>{
        if (!stripe || !eventId || !isMobile) return;
        const params = new URLSearchParams(window.location.search);
        const urlCurrency = params.get("currency");
        const urlAmount = params.get("amount");
        const parsedAmount = urlAmount ? parseFloat(urlAmount) : null;
        const urlCoverFee = params.get("coverFee");
        const parsedCoverFee = urlCoverFee ? urlCoverFee.toLowerCase() === "true" : false;
        if (urlCurrency && parsedAmount) {
            var ref, ref1;
            var _program, ref2;
            setModalData({
                ...modalData,
                currency: urlCurrency,
                amount: parsedAmount,
                program: (ref2 = (_program = modalData.program) !== null && _program !== void 0 ? _program : programs === null || programs === void 0 ? void 0 : (ref = programs[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase()) !== null && ref2 !== void 0 ? ref2 : "",
                payment: {
                    ...modalData.payment,
                    method: "APPLE_PAY",
                    coverPlatformFee: parsedCoverFee,
                    coverTrxFee: parsedCoverFee
                }
            });
            if (setIsOpen) setIsOpen(true);
            handleAlternativeMethods(parsedAmount, parsedCoverFee, urlCurrency, ()=>{
                setModalStage(ModalFlow[5]);
            });
        }
    // eslint-disable-next-line
    }, [
        stripe,
        elements,
        eventId
    ]);
    (0,react.useEffect)(()=>{
        const params = new URLSearchParams(window.location.search);
        var ref;
        const firstName = (ref = params.get("first")) !== null && ref !== void 0 ? ref : "";
        var ref1;
        const lastName = (ref1 = params.get("last")) !== null && ref1 !== void 0 ? ref1 : "";
        var ref2;
        const email = (ref2 = params.get("email")) !== null && ref2 !== void 0 ? ref2 : "";
        if (firstName || lastName || email) setModalData({
            ...modalData,
            donator: {
                ...modalData.donator,
                firstName,
                lastName,
                email
            }
        });
    }, []);
    (0,react.useEffect)(()=>{
        const customGiftAid = CUSTOM_GIFT_AID_COPY.find((a)=>a.eventId === eventId);
        if (!!customGiftAid) setGiftAidStep(customGiftAid.step);
    }, [
        eventId,
        isOpen
    ]);
    const handleAlternativeMethods = async (amount, coverFee, currency, onPaymentRequestReady)=>{
        if (!stripe) return;
        setLoading(true);
        const promise = new Promise((resolve, _reject)=>{
            /* in promise */ const trx = (0,Stripe_util/* getDonationTotal */.Ip)({
                amount: amount * 100,
                platformFee: platformFee,
                coverPlatformFee: coverFee
            });
            console.log("DEBUG: generating paymentRequestInstance");
            const paymentRequestInstance = stripe.paymentRequest({
                country: "GB",
                currency: currency.toLowerCase(),
                total: {
                    label: "Donation",
                    amount: Math.ceil(trx.total)
                },
                requestPayerName: true,
                requestPayerEmail: true
            });
            console.log("DEBUG: paymentRequestInstance:", paymentRequestInstance);
            paymentRequestInstance.canMakePayment().then((result)=>{
                if (result) {
                    setPaymentRequest(paymentRequestInstance);
                    if (onPaymentRequestReady) onPaymentRequestReady();
                }
                console.log("DEBUG: paymentRequestInstance resolved", result);
                return resolve(true);
            }).catch((error)=>{
                console.error("Error in canMakePayment:", error);
                return resolve(null);
            });
            paymentRequestInstance.on("paymentmethod", async (e)=>{
                var ref;
                const payerEmail = e.payerEmail;
                const [payerFirstName, payerLastName] = e.payerName ? e.payerName.split(" ") : [
                    undefined,
                    undefined
                ];
                setLoading(true);
                var ref1;
                const newPaymentIntent = await getPaymentIntent({
                    amount,
                    paymentMethodType: "card",
                    paymentMethodId: e.paymentMethod.id,
                    paymentMethodRegionCode: (ref1 = (ref = e.paymentMethod.card) === null || ref === void 0 ? void 0 : ref.country) !== null && ref1 !== void 0 ? ref1 : undefined,
                    includeFee: coverFee,
                    payerFirstName,
                    payerLastName,
                    payerEmail
                });
                if (newPaymentIntent === null || newPaymentIntent === void 0 ? void 0 : newPaymentIntent.error) {
                    setLoading(false);
                    setPaymentError(newPaymentIntent.error);
                    e.complete("fail");
                    return;
                }
                if (newPaymentIntent === null || newPaymentIntent === void 0 ? void 0 : newPaymentIntent.clientSecret) {
                    const { error: stripeError , paymentIntent  } = await stripe.confirmCardPayment(newPaymentIntent.clientSecret, {
                        payment_method: e.paymentMethod.id,
                        return_url: returnUrl
                    }, {
                        handleActions: false
                    });
                    if (stripeError) {
                        setLoading(false);
                        setPaymentError(stripeError.message);
                        e.complete("fail");
                        return;
                    }
                    setLoading(false);
                    setModalStage(ModalFlow[ModalFlow.length - 1]);
                    if (refetchDonations) refetchDonations();
                    e.complete("success");
                }
            });
            setLoading(false);
            setPaymentError("");
        /* in promise end */ });
        return promise;
    };
    const checkforAlternatePaymethods = async ()=>{
        const promise = new Promise((resolve, _reject)=>{
            if (!stripe) return resolve(null);
            const paymentRequestInstance = stripe.paymentRequest({
                country: "GB",
                currency: organisationCurrency ? organisationCurrency.toLowerCase() : "gbp",
                total: {
                    label: "Donation",
                    amount: Math.ceil(10 * 100)
                },
                requestPayerName: true,
                requestPayerEmail: true
            });
            paymentRequestInstance.canMakePayment().then((result)=>{
                console.log("DEBUG: keep to verify result on https env:", result);
                if (result) {
                    setAltPaymentEnabled(true);
                }
                return resolve(result);
            }).catch((error)=>{
                console.error("Error in canMakePayment:", error);
                return resolve(null);
            });
        });
        return promise;
    };
    const isGooglePayAvailable = async ()=>{
        if (!window.PaymentRequest) return false;
        const methodData = [
            {
                supportedMethods: "https://google.com/pay"
            }
        ];
        try {
            const request = new PaymentRequest(methodData, {
                total: {
                    label: "Verification Purchase",
                    amount: {
                        currency: "USD",
                        value: "0.01"
                    }
                }
            });
            return await request.canMakePayment();
        } catch (err) {
            return false;
        }
    };
    const amount = (modalData === null || modalData === void 0 ? void 0 : modalData.amount) ? parseFloat("".concat(modalData.amount)) : 0;
    const baseAmount = "".concat(currencies/* default */.Z[organisationCurrency !== null && organisationCurrency !== void 0 ? organisationCurrency : "GBP"].symbol).concat((0,util/* roundAmount */.Bq)(amount));
    const amountWithFee = "(".concat(currencies/* default */.Z[organisationCurrency !== null && organisationCurrency !== void 0 ? organisationCurrency : "GBP"].symbol).concat((0,util/* roundAmount */.Bq)((0,Stripe_util/* getDonationTotal */.Ip)({
        amount: amount * 100,
        platformFee,
        regionCode: (0,Stripe_util/* getBankingCountryByPaymentMethod */.zo)(paymentMethod),
        coverPlatformFee: true
    }).total / 100), ")");
    const feeOptions = [
        "No, not today (".concat(baseAmount, ")"),
        "Yes, cover the fees ".concat(amountWithFee)
    ];
    const donationTypeOptions = [
        "One-Time Donation",
        "Recurring Donation"
    ];
    const isContinueDisabled = (0,react.useMemo)(()=>{
        const { paymentType , donator , directDebit  } = modalData;
        // Validation Checks
        const isCardNumberCompleted = validPaymentDetails.number || stripeCardCompleted;
        const hasBasicCardValidations = !!donator.firstName && !!donator.lastName && !!donator.email && !!isCardNumberCompleted && !!validPaymentDetails.mmaa && !!validPaymentDetails.cvc;
        //payment.card_details?.address &&
        //payment.card_details?.post_code
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        const isValidEmail = emailRegex.test(donator.email);
        const hasBasicDonatorInfo = !!isValidEmail && !!donator.firstName && !!donator.lastName && !!modalData.addressLine1 && !!modalData.addressCity && !!modalData.addressPostalCode && !!modalData.addressCountry;
        const hasDirectDebitInfo = !!directDebit.name && !!directDebit.number && !!directDebit.sort && !!directDebit.confirmDirectDebit;
        // Step-based Logic
        if ((modalStage === null || modalStage === void 0 ? void 0 : modalStage.step) === 1) {
            // Step 1 Validation
            if (!modalData.amount || modalData.amount === 0 || !hasBasicDonatorInfo) {
                return true;
            }
        } else if ((modalStage === null || modalStage === void 0 ? void 0 : modalStage.step) === 2) {
            // Step 2 Validation for Card Payment
            if (paymentType === graphql/* PaymentType.Card */.uG.Card && (modalData.payment.method === "APPLE_PAY" || modalData.payment.method === "GOOGLE_PAY")) {
                return false;
            }
            if (paymentType === graphql/* PaymentType.Card */.uG.Card && !hasBasicCardValidations) {
                return true;
            }
            // Step 2 Validation for Direct Debit
            if (paymentType === graphql/* PaymentType.DirectDebit */.uG.DirectDebit && !hasDirectDebitInfo) {
                return true;
            }
        }
        return false;
    }, [
        modalData,
        modalStage,
        validPaymentDetails,
        stripeCardCompleted
    ]);
    (0,react.useEffect)(()=>{
        if (window.PaymentRequest) {
            const checkGooglePayAvailability = async ()=>{
                const available = await isGooglePayAvailable();
                setIsGooglePayEnabled(available);
            };
            checkGooglePayAvailability();
        }
    }, [
        window.PaymentRequest
    ]);
    const getPaymentIntent = async (param)=>{
        let { amount , paymentMethodRegionCode , paymentMethodId , paymentMethodType , includeFee , payerFirstName , payerLastName , payerEmail  } = param;
        var ref, ref1, ref2, ref3, ref4;
        const { donator , payment , paymentType  } = modalData;
        const { coverPlatformFee , coverTrxFee , isRecurring  } = payment;
        let trx;
        if (!isRecurring && paymentType !== graphql/* PaymentType.DirectDebit */.uG.DirectDebit) {
            trx = (0,Stripe_util/* getDonationTotal */.Ip)({
                amount: amount * 100,
                platformFee,
                regionCode: paymentMethodRegionCode,
                coverPlatformFee
            });
        }
        var ref5, ref6, ref7;
        const response = await eventDonationCreatePaymentIntent({
            variables: {
                input: {
                    donationUrl: (ref5 = eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.donationUrl) !== null && ref5 !== void 0 ? ref5 : "",
                    eventName: eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.title,
                    organizationName: eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.organizationName,
                    message: (ref6 = modalData === null || modalData === void 0 ? void 0 : modalData.message) !== null && ref6 !== void 0 ? ref6 : "",
                    amount: Math.ceil(amount * 100),
                    firstName: payerFirstName || donator.firstName,
                    lastName: payerLastName || donator.lastName,
                    email: payerEmail || donator.email,
                    currency: organisationCurrency.toLowerCase(),
                    address: (ref7 = modalData === null || modalData === void 0 ? void 0 : (ref = modalData.payment) === null || ref === void 0 ? void 0 : (ref1 = ref.card_details) === null || ref1 === void 0 ? void 0 : ref1.address) !== null && ref7 !== void 0 ? ref7 : "",
                    giftAid: modalData === null || modalData === void 0 ? void 0 : modalData.payment.giftAidConfirm,
                    paymentMethodId: paymentMethodId,
                    paymentMethodType: paymentMethodType !== null && paymentMethodType !== void 0 ? paymentMethodType : "card",
                    paymentType: paymentType,
                    paymentMethodRegionCode: paymentMethodRegionCode,
                    selectedProgram: modalData.program,
                    statisticId: statisticId,
                    eventId,
                    coverFee: coverPlatformFee ? "true" : "false",
                    homeAddress: modalData.homeAddress,
                    visibility: modalData.visibility,
                    donorTitle: (ref2 = modalData.donator) === null || ref2 === void 0 ? void 0 : ref2.title,
                    donorDob: (ref3 = modalData.donator) === null || ref3 === void 0 ? void 0 : ref3.dob,
                    allowEmailContact: modalData.allowEmailContact,
                    allowTelephoneContact: modalData.allowTelephoneContact,
                    addressLine1: modalData.addressLine1,
                    addressLine2: modalData.addressLine2,
                    addressLine3: modalData.addressLine3,
                    addressPostalCode: modalData.addressPostalCode,
                    addressCity: modalData.addressCity,
                    addressCountry: modalData.addressCountry,
                    addressPhone: modalData.addressPhone,
                    directDebitName: modalData.directDebit.name,
                    directDebitNumber: modalData.directDebit.number,
                    directDebitSort: modalData.directDebit.sort,
                    directDebitConfirmed: modalData.directDebit.confirmDirectDebit,
                    directDebitPeriod: modalData.selectedRecurrency
                }
            }
        });
        return response === null || response === void 0 ? void 0 : (ref4 = response.data) === null || ref4 === void 0 ? void 0 : ref4.eventDonationCreatePaymentIntent;
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        setPaymentError("");
        if (loading) return;
        const results = (0,validation/* validate */.Gu)(modalData, (0,validation/* getValidationRules */.sl)("Donation"));
        if (!results.error) {
            if (disablePayment) {
                var ref, ref1;
                setLoading(true);
                const { currency , amount , message , donatedAt , program , payment , paymentType , directDebit , visibility , addressCity , donator , selectedRecurrency , homeAddress , addressLine1 , addressLine2 , addressLine3 , addressPhone , addressCountry , addressPostalCode , allowEmailContact , allowTelephoneContact  } = modalData;
                if (onComplete) onComplete({
                    amount: typeof amount === "string" ? parseInt(amount) : amount,
                    currency,
                    message,
                    donatedAt,
                    program: program,
                    payment: {
                        giftAid: payment.giftAid,
                        giftAidConfirm: payment.giftAidConfirm,
                        paymentType
                    },
                    statisticId,
                    donorTitle: donator.title,
                    firstName: donator.firstName,
                    lastName: donator.lastName,
                    email: donator.email,
                    donorDob: donator.dob,
                    organizationName: event === null || event === void 0 ? void 0 : (ref = event.event) === null || ref === void 0 ? void 0 : ref.organizationName,
                    eventId,
                    giftAid: !!payment.giftAid,
                    eventName: event === null || event === void 0 ? void 0 : (ref1 = event.event) === null || ref1 === void 0 ? void 0 : ref1.title,
                    selectedProgram: program !== null && program !== void 0 ? program : "",
                    paymentType,
                    coverFee: payment.coverPlatformFee,
                    address: homeAddress,
                    homeAddress,
                    visibility: visibility,
                    allowEmailContact,
                    allowTelephoneContact,
                    addressLine1,
                    addressLine2,
                    addressLine3,
                    addressPostalCode,
                    addressCity,
                    addressCountry,
                    addressPhone,
                    directDebitName: directDebit.name,
                    directDebitNumber: directDebit.number,
                    directDebitSort: directDebit.sort,
                    directDebitConfirmed: directDebit.confirmDirectDebit,
                    directDebitPeriod: selectedRecurrency,
                    donation: "",
                    fee: "",
                    total: "",
                    created: donatedAt
                });
                return;
            }
            if ((modalData === null || modalData === void 0 ? void 0 : modalData.paymentType) === graphql/* PaymentType.DirectDebit */.uG.DirectDebit) {
                setLoading(true);
                const paymentIntent = await getPaymentIntent({
                    amount: modalData.amount
                });
                if ((paymentIntent === null || paymentIntent === void 0 ? void 0 : paymentIntent.clientSecret) === "DIRECTDEBIT") {
                    if (refetchDonations) refetchDonations();
                    setModalStage(ModalFlow[ModalFlow.length - 1]);
                } else {
                    setLoading(false);
                    setDisable(true);
                    setPaymentError("It seems something went wrong with your details. Please double-check your details and verify they are correct.");
                }
                setLoading(false);
                return;
            }
            if (!paymentMethod) return;
            if (!stripe) return;
            setLoading(true);
            const paymentIntent1 = await getPaymentIntent({
                amount: modalData.amount,
                paymentMethodId: paymentMethod.id,
                paymentMethodRegionCode: (0,Stripe_util/* getBankingCountryByPaymentMethod */.zo)(paymentMethod)
            });
            try {
                if (paymentIntent1 === null || paymentIntent1 === void 0 ? void 0 : paymentIntent1.clientSecret) {
                    await stripe.confirmCardPayment(paymentIntent1.clientSecret, {
                        payment_method: paymentMethod.id,
                        return_url: returnUrl
                    }, {
                        handleActions: false
                    }).then((res)=>{
                        var ref;
                        if (res.error) {
                            setPaymentError(res.error.message);
                            return;
                        }
                        // Payment requires further authentication
                        if (res.paymentIntent.status === "requires_action") {
                            var ref1, ref2;
                            setPayment3DSUrl((ref1 = res.paymentIntent.next_action) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.redirect_to_url) === null || ref2 === void 0 ? void 0 : ref2.url);
                            return;
                        }
                        // Payment was not successful
                        if (((ref = res.paymentIntent) === null || ref === void 0 ? void 0 : ref.status) !== "succeeded") {
                            setDisable(true);
                            setPaymentError("It seems something went wrong with your card payment. Please double-check your card details and verify that your card is active.");
                            return;
                        }
                        // Payment was successful
                        if (res.paymentIntent.status === "succeeded") {
                            setModalStage(ModalFlow[ModalFlow.length - 1]);
                        }
                    }).finally(()=>setLoading(false));
                    if (refetchDonations) refetchDonations();
                } else {
                    setLoading(false);
                    var ref2;
                    setPaymentError((ref2 = paymentIntent1 === null || paymentIntent1 === void 0 ? void 0 : paymentIntent1.error) !== null && ref2 !== void 0 ? ref2 : "There was an unexpected error, please try again.");
                }
            } catch (ex) {
                console.warn(ex);
                setPaymentError("There was an unexpected error, please refresh and try again.");
                setLoading(false);
            }
        } else {
            // setModalStage(results.error.step)
            console.log({
                error: results.error
            });
            setPaymentError(results.error.message);
        }
    };
    const handle3DSComplete = (url)=>{
        if (!url) return;
        try {
            var ref, ref1, ref2, ref3, ref4;
            const paymentIntentSecret = (ref4 = (ref3 = (ref2 = (ref = url === null || url === void 0 ? void 0 : url.split("?")) === null || ref === void 0 ? void 0 : (ref1 = ref[1]) === null || ref1 === void 0 ? void 0 : ref1.split("&")) === null || ref2 === void 0 ? void 0 : ref2.find((query)=>{
                var ref;
                return ((ref = query === null || query === void 0 ? void 0 : query.split("=")) === null || ref === void 0 ? void 0 : ref[0]) === "payment_intent_client_secret";
            })) === null || ref3 === void 0 ? void 0 : ref3.split("=")) === null || ref4 === void 0 ? void 0 : ref4[1];
            if (!!paymentIntentSecret && !!stripe) {
                stripe.retrievePaymentIntent(paymentIntentSecret).then(function(result) {
                    if (result.error) {
                        setPaymentError("There was an unexpected error, please refresh and try again.");
                    } else {
                        if (result.paymentIntent.status === "succeeded") {
                            setModalStage(ModalFlow[ModalFlow.length - 1]);
                        } else if (result.paymentIntent.status === "requires_payment_method") {
                            setPaymentError("There was an error with your payment method, please try again.");
                        }
                    }
                }).finally(()=>{
                    setLoading(false);
                    setPayment3DSUrl(null);
                });
            }
        } catch (_ex) {
            console.error(_ex);
        }
    };
    (0,react.useEffect)(()=>{
        if (payment3DSUrl) window.addEventListener("message", function(e) {
            if (e.data === "3DS-authentication-complete") {
                handle3DSComplete(payment3DSUrl);
            }
        }, false);
    }, [
        payment3DSUrl
    ]);
    const preparePaymentMethod = async ()=>{
        if (loading) return;
        if (!stripe) return;
        if (!elements) return;
        const cardNumberElement = elements.getElement(react_stripe_umd.CardNumberElement);
        const cardExpiryElement = elements.getElement(react_stripe_umd.CardExpiryElement);
        const cardCvcElement = elements.getElement(react_stripe_umd.CardCvcElement);
        const isCardNumberCompleted = validPaymentDetails.number || stripeCardCompleted;
        if (!cardNumberElement || !isCardNumberCompleted) return setPaymentError("A valid card number is required");
        if (!cardExpiryElement || !validPaymentDetails.mmaa) return setPaymentError("Expiry date is not valid");
        if (!cardCvcElement || !validPaymentDetails.cvc) return setPaymentError("CVC is not valid");
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        const isValidMail = emailRegex.test(modalData.donator.email);
        if (!isValidMail) return setPaymentError("Email address is not valid");
        const { paymentMethod , error  } = await stripe.createPaymentMethod({
            type: "card",
            card: cardNumberElement,
            billing_details: {
                address: {
                    postal_code: modalData.payment.card_details.post_code
                }
            }
        });
        if (!error) {
            setPaymentError("");
            setPaymentMethod(paymentMethod);
        } else {
            setLoading(false);
            setPaymentError(error.message);
        }
        (0,Stripe_util/* getBankingCountryByPaymentMethod */.zo)(paymentMethod);
        return !error;
    };
    const handleSetModalStage = async (newStage)=>{
        if (newStage.step === 2) {
            checkforAlternatePaymethods();
            const post_code = (modalData === null || modalData === void 0 ? void 0 : modalData.addressPostalCode) || "";
            const address = [
                modalData.addressLine1,
                modalData.addressLine2,
                modalData.addressLine3,
                modalData.addressCity,
                modalData.addressCountry
            ].filter(Boolean).join(". ") || "";
            // Pre-fill address fields if possible
            if (modalData.paymentType !== graphql/* PaymentType.DirectDebit */.uG.DirectDebit) {
                setModalData({
                    ...modalData,
                    /*payment: {
            ...modalData.payment,
            card_details: {
              ...modalData.payment.card_details,
              address,
              post_code,
            },
          },*/ homeAddress: [
                        address,
                        post_code
                    ].filter(Boolean).join(". ") || ""
                });
            } else {
                setModalData({
                    ...modalData,
                    homeAddress: [
                        address,
                        post_code
                    ].filter(Boolean).join(". ") || ""
                });
            }
            if (modalData.paymentType !== graphql/* PaymentType.DirectDebit */.uG.DirectDebit && disablePayment) return setModalStage(ModalFlow[3]);
            if (modalData.amount > 0) setModalStage(newStage);
        } else if (newStage.step === 3) {
            setDisable(false);
            if (configSkipGiftAidStep) newStage = {
                title: "Details",
                step: 4
            };
            if (modalData.payment.method === "CARD" && modalData.paymentType !== graphql/* PaymentType.DirectDebit */.uG.DirectDebit) {
                const completed = await preparePaymentMethod();
                if (completed) setModalStage(newStage);
            } else {
                /*if (isMobile) {
          const { amount, payment } = modalData
          handleAlternativeMethods(
            amount,
            payment.coverFee,
            organisationCurrency
          )
          setModalStage(newStage)
        } else {
          setModalStage(newStage)
        }*/ const { amount , payment  } = modalData;
                const altMethodAvailable = await handleAlternativeMethods(amount, payment.coverPlatformFee, organisationCurrency);
                if (altMethodAvailable) {
                    setModalStage(newStage);
                } else {
                    setPaymentError("We're sorry to inform you that alternative payment methods are not available on this device. Please try using a different device or make your donation with a card.");
                }
            }
        } else if (newStage.step === 4) {
            var ref;
            if (giftAidStep === 1 && (modalData === null || modalData === void 0 ? void 0 : (ref = modalData.payment) === null || ref === void 0 ? void 0 : ref.giftAid)) {
                setGiftAidStep(2);
                return;
            }
            setModalStage(newStage);
        } else {
            setModalStage(newStage);
        }
    };
    const amountChoices = [
        {
            title: "".concat(currencies/* default */.Z[organisationCurrency !== null && organisationCurrency !== void 0 ? organisationCurrency : "GBP"].symbol, "10"),
            value: 10
        },
        {
            title: "".concat(currencies/* default */.Z[organisationCurrency !== null && organisationCurrency !== void 0 ? organisationCurrency : "GBP"].symbol, "25"),
            value: 25
        },
        {
            title: "".concat(currencies/* default */.Z[organisationCurrency !== null && organisationCurrency !== void 0 ? organisationCurrency : "GBP"].symbol, "100"),
            value: 100
        },
        {
            title: "".concat(currencies/* default */.Z[organisationCurrency !== null && organisationCurrency !== void 0 ? organisationCurrency : "GBP"].symbol, "350"),
            value: 350
        },
        {
            title: "".concat(currencies/* default */.Z[organisationCurrency !== null && organisationCurrency !== void 0 ? organisationCurrency : "GBP"].symbol, "500"),
            value: 500
        },
        {
            title: "".concat(currencies/* default */.Z[organisationCurrency !== null && organisationCurrency !== void 0 ? organisationCurrency : "GBP"].symbol, "1000"),
            value: 1000
        }
    ];
    const paymentTypeChoices = [
        {
            title: "One-time card",
            value: graphql/* PaymentType.Card */.uG.Card
        },
        {
            title: "Regular Direct Debit",
            value: graphql/* PaymentType.DirectDebit */.uG.DirectDebit
        }
    ];
    const recurrentChoices = [
        {
            title: "Monthly",
            value: "Monthly"
        },
        {
            title: "Quarterly",
            value: "Quarterly"
        },
        {
            title: "Annually",
            value: "Annually"
        }
    ];
    const visibilityChoices = [
        {
            title: "Name & amount",
            value: "Name & amount"
        },
        {
            title: "Name only",
            value: "Name only"
        },
        {
            title: "Anonymous",
            value: "Anonymous"
        }
    ];
    const programOptions = (0,react.useMemo)(()=>{
        return programs && programs.length > 0 ? programs.filter((p)=>p.active && p.enabled).map((program, i)=>({
                value: program.title.toUpperCase(),
                label: program.title,
                selected: i === 0
            })) : [];
    }, [
        programs
    ]);
    const donationFormModal = ()=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
        const getDescriptionContent = ()=>{
            var ref;
            const desc = (ref = programs === null || programs === void 0 ? void 0 : programs.find((pg)=>pg.title.toUpperCase() === modalData.program.toUpperCase())) === null || ref === void 0 ? void 0 : ref.description;
            if (!!desc && desc === eventDetails.description) return /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextDisplay/* default */.Z, {
                descriptionJson: desc
            });
            return desc;
        };
        const baseClass = showInline ? "min-h-screen flex flex-col relative !min-h-[650px] rounded-xl ".concat(theme.type === "DARK" ? "bg-midnight-dark" : "bg-white", " !z-9999") : "min-h-screen flex flex-col relative !min-h-[650px] max-h-[720px] h-full rounded rounded-xl ".concat(theme.type === "DARK" ? "bg-midnight-dark" : "bg-white", " !z-9999");
        var ref13, ref14, ref15, ref16, ref17;
        const innerConent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
            className: baseClass,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "sticky top-0 z-20 flex justify-between items-center p-4 rounded-tl-xl rounded-tr-xl",
                    style: {
                        backgroundColor: showInline ? "white" : theme.foregroundColour
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "flex items-center justify-start",
                            children: [
                                modalStage.step >= (programs && programs.length > 0 ? 1 : 2) && modalStage.step < 6 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineLeft */.CF5, {
                                    className: "cursor-pointer mr-4",
                                    onClick: ()=>setModalStage(ModalFlow[modalStage.step - 1])
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "font-bold text-sm",
                                    children: modalStage.title
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "flex items-center space-x-1 sm:space-x-2 absolute left-1/2 transform translate-x-m-50 top-5.5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    show: programs && programs.length > 0,
                                    className: "rounded-full w-3 h-3 border",
                                    style: {
                                        backgroundColor: modalStage.step >= 0 ? StaticColours.v2.blue : theme.backgroundColour
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "rounded-full w-3 h-3 border",
                                    style: {
                                        backgroundColor: modalStage.step >= 1 ? StaticColours.v2.blue : theme.backgroundColour
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "rounded-full w-3 h-3 border",
                                    style: {
                                        backgroundColor: modalStage.step >= 2 ? StaticColours.v2.blue : theme.backgroundColour
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "rounded-full w-3 h-3 border",
                                    style: {
                                        backgroundColor: modalStage.step >= 3 ? StaticColours.v2.blue : theme.backgroundColour
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "rounded-full w-3 h-3 border",
                                    style: {
                                        backgroundColor: modalStage.step >= 4 ? StaticColours.v2.blue : theme.backgroundColour
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "rounded-full w-3 h-3 border",
                                    style: {
                                        backgroundColor: modalStage.step >= 5 ? StaticColours.v2.blue : theme.backgroundColour
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            show: modalStage.step <= 5,
                            className: "flex text-sm",
                            children: [
                                ((ref13 = modalStage === null || modalStage === void 0 ? void 0 : modalStage.step) !== null && ref13 !== void 0 ? ref13 : 0) + 1,
                                "/",
                                hasPrograms ? ModalFlow.length - 1 : ModalFlow.length - 2
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            show: modalStage.step === 6,
                            type: "tertiary",
                            onClick: (e)=>{
                                if (setIsOpen) setIsOpen(false);
                                e.stopPropagation();
                                setModalData((0,lodash.cloneDeep)(initialState));
                                setModalStage(ModalFlow[0]);
                                setGiftAidStep(1);
                                setLoading(false);
                                setStripeCardCompleted(false);
                                setPaymentMethod(undefined);
                            },
                            className: "border-none",
                            textColor: "#000",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoClose */.bjh, {
                                className: "w-8 h-8"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "relative p-3 pb-10 md:pb-3 sm:p-6 mb-16 xs:mb-2 md:mb-8 xl:mb-16 flex-grow",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            show: modalStage.step === 0,
                            className: "flex flex-col py-1 h-full",
                            children: [
                                programOptions && programOptions.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "-mb-5 ml-3 bg-white font-medium z-50 pl-[10px] w-[270px]",
                                            children: "Select your donation programme"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "flex justify-start items-center mb-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownInput/* DropdownInput */.f, {
                                                className: "w-full -mt-4",
                                                label: "",
                                                placeholder: "Select a fundraising programme",
                                                options: programOptions,
                                                onChange: (data)=>{
                                                    setModalData({
                                                        ...modalData,
                                                        program: data
                                                    });
                                                },
                                                value: modalData.program || (programs && programs.length > 0 ? programs[0].title.toUpperCase() : "")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    show: modalData.program.length > 0,
                                    className: "mt-0 flex justify-center items-center flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "flex justify-center items-center w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "w-full",
                                                show: !!((ref = programs === null || programs === void 0 ? void 0 : programs.find((pg)=>pg.title.toUpperCase() === modalData.program.toUpperCase())) === null || ref === void 0 ? void 0 : (ref1 = ref.media) === null || ref1 === void 0 ? void 0 : ref1.url),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: (ref14 = (ref2 = programs === null || programs === void 0 ? void 0 : programs.find((pg)=>pg.title.toUpperCase() === modalData.program.toUpperCase())) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.media) === null || ref3 === void 0 ? void 0 : ref3.url) !== null && ref14 !== void 0 ? ref14 : "",
                                                    alt: (ref15 = (ref4 = programs === null || programs === void 0 ? void 0 : programs.find((pg)=>pg.title.toUpperCase() === modalData.program.toUpperCase())) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.media) === null || ref5 === void 0 ? void 0 : ref5.title) !== null && ref15 !== void 0 ? ref15 : "Title",
                                                    className: "object-cover w-full max-h-[225px] rounded-2xl",
                                                    layout: "responsive",
                                                    width: 300,
                                                    height: 50
                                                }, (ref16 = (ref6 = programs === null || programs === void 0 ? void 0 : programs.find((pg)=>pg.title.toUpperCase() === modalData.program.toUpperCase())) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.media) === null || ref7 === void 0 ? void 0 : ref7.title) !== null && ref16 !== void 0 ? ref16 : "Title")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "flex flex-row align-start items-center justify-start mt-4 max-w-[600px] w-[100%]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "text-xl font-medium leading-[2rem]",
                                                children: (ref8 = programs === null || programs === void 0 ? void 0 : programs.find((pg)=>pg.title.toUpperCase() === modalData.program.toUpperCase())) === null || ref8 === void 0 ? void 0 : ref8.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "mt-1 text-sm text-justify leading-relaxed w-full",
                                            children: getDescriptionContent()
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            show: modalStage.step === 1,
                            className: "flex flex-col py-2",
                            children: [
                                !onlyOneTimePayments && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "pb-2 font-medium",
                                            children: "Payment Method*"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-sm mb-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemPicker/* ItemPicker */.H, {
                                                itemClass: "!w-1/2",
                                                choices: (0,register_util/* getRegistrationConfig */.rS)(register_util/* CONFIG_OPTIONS.ALLOW_DIRECT_DEBIT */.ce.ALLOW_DIRECT_DEBIT, {
                                                    event: eventDetails
                                                }) ? paymentTypeChoices : [
                                                    paymentTypeChoices[0]
                                                ],
                                                onClick: (value)=>setModalData({
                                                        ...modalData,
                                                        paymentType: value
                                                    }),
                                                value: modalData.paymentType
                                            })
                                        }),
                                        (modalData === null || modalData === void 0 ? void 0 : modalData.paymentType) === graphql/* PaymentType.DirectDebit */.uG.DirectDebit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemPicker/* ItemPicker */.H, {
                                            itemClass: "!w-1/3",
                                            choices: recurrentChoices,
                                            onClick: (value)=>setModalData({
                                                    ...modalData,
                                                    selectedRecurrency: value
                                                }),
                                            value: modalData.selectedRecurrency
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "!w-1/3 mb-14"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: '"pb-2 font-medium '.concat(onlyOneTimePayments ? "mt-0" : "mt-4", '"'),
                                    children: "Amount You Would Like to Donate"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemPicker/* ItemPicker */.H, {
                                    choices: amountChoices,
                                    onClick: (value)=>setModalData({
                                            ...modalData,
                                            amount: value
                                        }),
                                    value: modalData.amount
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "flex justify-start items-center w-full -mt-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceInput/* PriceInput */.t, {
                                        hint: "",
                                        className: "w-full",
                                        currencySymbol: currencies/* default */.Z[organisationCurrency !== null && organisationCurrency !== void 0 ? organisationCurrency : "GBP"].symbol,
                                        onChange: (data)=>{
                                            setModalData({
                                                ...modalData,
                                                amount: data
                                            });
                                        },
                                        value: modalData === null || modalData === void 0 ? void 0 : modalData.amount
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "mb-4 font-medium mt-4",
                                    children: "Personal Information"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "-mb-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                        label: "Title",
                                        value: modalData.donator.title,
                                        onChange: (value)=>setModalData({
                                                ...modalData,
                                                donator: {
                                                    ...modalData.donator,
                                                    title: value
                                                }
                                            }),
                                        type: "text",
                                        placeholder: "Title",
                                        className: "bg-transparent rounded text-sm outline-none w-full mt-0",
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "w-full flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                            label: "First Name",
                                            value: modalData.donator.firstName,
                                            onChange: (value)=>setModalData({
                                                    ...modalData,
                                                    donator: {
                                                        ...modalData.donator,
                                                        firstName: value
                                                    }
                                                }),
                                            type: "text",
                                            placeholder: "First Name",
                                            className: "bg-transparent rounded text-sm outline-none w-1/2 border-box pr-1",
                                            validations: {
                                                minLength: {
                                                    value: 2,
                                                    message: "First Name must be at least 2 characters"
                                                },
                                                maxLength: {
                                                    value: 70,
                                                    message: "First Name must be less than 70 characters"
                                                },
                                                pattern: {
                                                    value: /^[a-z ,.'-]+$/i,
                                                    message: "First Name must consist of letters only"
                                                }
                                            },
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                            label: "Last Name",
                                            value: modalData.donator.lastName,
                                            onChange: (value)=>setModalData({
                                                    ...modalData,
                                                    donator: {
                                                        ...modalData.donator,
                                                        lastName: value
                                                    }
                                                }),
                                            type: "text",
                                            placeholder: "Last Name",
                                            className: "bg-transparent rounded text-sm outline-none w-1/2 border-box",
                                            validations: {
                                                minLength: {
                                                    value: 2,
                                                    message: "Last Name must be at least 2 characters"
                                                },
                                                maxLength: {
                                                    value: 70,
                                                    message: "Last Name must be less than 70 characters"
                                                },
                                                pattern: {
                                                    value: /^[a-z ,.'-]+$/i,
                                                    message: "Last Name must consist of letters only"
                                                }
                                            },
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "w-full flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                            label: "Email",
                                            value: modalData.donator.email,
                                            onChange: (value)=>setModalData({
                                                    ...modalData,
                                                    donator: {
                                                        ...modalData.donator,
                                                        email: value
                                                    }
                                                }),
                                            type: "email",
                                            placeholder: "Email",
                                            className: "bg-transparent rounded text-sm outline-none w-1/2 mt-0 mr-1",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "w-1/2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker, {
                                                    selected: (modalData === null || modalData === void 0 ? void 0 : (ref9 = modalData.donator) === null || ref9 === void 0 ? void 0 : ref9.dob) ? moment_default()(modalData === null || modalData === void 0 ? void 0 : (ref10 = modalData.donator) === null || ref10 === void 0 ? void 0 : ref10.dob).toDate() : null,
                                                    onChange: (date)=>{
                                                        const dob = date === null || date === void 0 ? void 0 : date.toISOString();
                                                        if (dob) {
                                                            setModalData({
                                                                ...modalData,
                                                                donator: {
                                                                    ...modalData.donator,
                                                                    dob
                                                                }
                                                            });
                                                        }
                                                    },
                                                    showYearDropdown: true,
                                                    scrollableYearDropdown: true,
                                                    yearDropdownItemNumber: 100,
                                                    minDate: moment_default()().subtract(100, "years").toDate(),
                                                    maxDate: moment_default()().toDate(),
                                                    isClearable: true,
                                                    wrapperClassName: "w-full",
                                                    popperClassName: "!z-20",
                                                    autoComplete: "off",
                                                    dateFormat: "dd/MM/yyyy",
                                                    showTimeInput: false,
                                                    placeholderText: "DOB (DD/MM/YYYY)",
                                                    className: "rounded-2xl transition-all bg-transparent border rounded px-4 py-4 text-sm outline-none cursor-pointer w-full",
                                                    onChangeRaw: (e)=>{
                                                        const inputValue = e.target.value;
                                                        const parsedDate = moment_default()(inputValue, "DD/MM/YYYY", true);
                                                        // Check if date is valid before setting it
                                                        if (parsedDate.isValid()) {
                                                            setModalData({
                                                                ...modalData,
                                                                donator: {
                                                                    ...modalData.donator,
                                                                    dob: parsedDate.toISOString()
                                                                }
                                                            });
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "text-xs ml-1",
                                                    children: "To help identify you on our database"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "font-medium mt-4",
                                            children: "Home address"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                            required: (0,validation/* isFieldRequired */.zx)(validation/* DonationRules.find */.HO.find((f)=>f[0].includes("addressLine1"))),
                                            value: modalData.addressLine1,
                                            onChange: (value)=>setModalData({
                                                    ...modalData,
                                                    addressLine1: value
                                                }),
                                            label: "Address line 1",
                                            type: "text",
                                            placeholder: "Address line 1",
                                            className: "bg-transparent rounded text-sm outline-none w-full",
                                            validations: {
                                                minLength: {
                                                    value: 2,
                                                    message: "Address must be at least 2 characters"
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                            required: (0,validation/* isFieldRequired */.zx)(validation/* DonationRules.find */.HO.find((f)=>f[0].includes("addressLine2"))),
                                            value: modalData.addressLine2,
                                            onChange: (value)=>setModalData({
                                                    ...modalData,
                                                    addressLine2: value
                                                }),
                                            label: "Address line 2",
                                            type: "text",
                                            placeholder: "Address line 2",
                                            className: "bg-transparent rounded text-sm outline-none w-full",
                                            validations: {
                                                minLength: {
                                                    value: 2,
                                                    message: "Address must be at least 2 characters"
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                            required: (0,validation/* isFieldRequired */.zx)(validation/* DonationRules.find */.HO.find((f)=>f[0].includes("addressLine3"))),
                                            value: modalData.addressLine3,
                                            onChange: (value)=>setModalData({
                                                    ...modalData,
                                                    addressLine3: value
                                                }),
                                            label: "Address line 3",
                                            type: "text",
                                            placeholder: "Address line 3",
                                            className: "bg-transparent rounded text-sm outline-none w-full",
                                            validations: {
                                                minLength: {
                                                    value: 2,
                                                    message: "Address must be at least 2 characters"
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "w-full flex -mt-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                                    required: (0,validation/* isFieldRequired */.zx)(validation/* DonationRules.find */.HO.find((f)=>f[0].includes("addressCity"))),
                                                    value: modalData.addressCity,
                                                    onChange: (value)=>setModalData({
                                                            ...modalData,
                                                            addressCity: value
                                                        }),
                                                    label: "City/Town",
                                                    type: "text",
                                                    placeholder: "City/Town",
                                                    className: "bg-transparent rounded text-sm outline-none w-1/2 border-box pr-1",
                                                    validations: {
                                                        minLength: {
                                                            value: 2,
                                                            message: "Address must be at least 2 characters"
                                                        }
                                                    },
                                                    autoComplete: "address-level2"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                                    required: (0,validation/* isFieldRequired */.zx)(validation/* DonationRules.find */.HO.find((f)=>f[0].includes("addressPostalCode"))),
                                                    value: modalData.addressPostalCode,
                                                    onChange: (value)=>setModalData({
                                                            ...modalData,
                                                            addressPostalCode: value
                                                        }),
                                                    label: "Postal Code",
                                                    type: "text",
                                                    placeholder: "Postal Code",
                                                    className: "bg-transparent rounded text-sm outline-none w-1/2 border-box",
                                                    validations: {
                                                        minLength: {
                                                            value: 2,
                                                            message: "Address must be at least 2 characters"
                                                        }
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "w-full flex -mt-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownInput/* DropdownInput */.f, {
                                                    required: (0,validation/* isFieldRequired */.zx)(validation/* DonationRules.find */.HO.find((f)=>f[0].includes("addressCountry"))),
                                                    label: "country",
                                                    className: "w-full",
                                                    placeholder: "Country",
                                                    bgColor: "bg-white",
                                                    options: LOCATIONS.map((country)=>({
                                                            value: country.toLowerCase(),
                                                            label: country
                                                        })),
                                                    onChange: (data)=>{
                                                        setModalData({
                                                            ...modalData,
                                                            addressCountry: data
                                                        });
                                                    },
                                                    overrideFullLabelClass: "flex flex-col space-y-1 text-sm mt-5 w-1/2 pr-[7px] pl-1",
                                                    value: (modalData === null || modalData === void 0 ? void 0 : (ref11 = modalData.addressCountry) === null || ref11 === void 0 ? void 0 : ref11.toLowerCase()) || "united kingdom"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                                    required: (0,validation/* isFieldRequired */.zx)(validation/* DonationRules.find */.HO.find((f)=>f[0].includes("addressPhone"))),
                                                    value: modalData.addressPhone,
                                                    onChange: (value)=>setModalData({
                                                            ...modalData,
                                                            addressPhone: value
                                                        }),
                                                    label: "Telephone",
                                                    type: "text",
                                                    placeholder: "Telephone number",
                                                    className: "bg-transparent rounded text-sm outline-none w-1/2 border-box",
                                                    validations: {
                                                        minLength: {
                                                            value: 2,
                                                            message: "Address must be at least 2 characters"
                                                        }
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            show: modalStage.step === 2,
                            className: "flex flex-col py-2 pt-2",
                            children: [
                                isMobile && modalData.paymentType !== graphql/* PaymentType.DirectDebit */.uG.DirectDebit && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "font-medium",
                                            children: "Select your Payment Method"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "flex justify-center items-center border border-forumm_gray mt-4 rounded-2xl h-13",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    className: "w-1/3 border-0 bg-red-400 !h-12 rounded-2xl",
                                                    title: "Card",
                                                    type: "square",
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineCreditCard */.km2, {}),
                                                    onClick: ()=>{
                                                        setModalData({
                                                            ...modalData,
                                                            payment: {
                                                                ...modalData.payment,
                                                                method: "CARD"
                                                            }
                                                        });
                                                    },
                                                    textColor: "#000",
                                                    backgroundColor: modalData.payment.method === "CARD" ? selectionColour : theme.backgroundColour
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    className: "w-1/3 border-0 !h-12 rounded-2xl",
                                                    type: "square",
                                                    title: "Pay",
                                                    disabled: !window.ApplePaySession || !altPaymentEnabled,
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiFillApple */.wM3, {}),
                                                    textColor: "#000",
                                                    onClick: (data)=>{
                                                        setModalData({
                                                            ...modalData,
                                                            payment: {
                                                                ...modalData.payment,
                                                                method: "APPLE_PAY"
                                                            }
                                                        });
                                                    },
                                                    backgroundColor: modalData.payment.method === "APPLE_PAY" ? selectionColour : theme.backgroundColour
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    className: "w-1/3 border-0 !h-12 rounded-2xl",
                                                    type: "square",
                                                    title: "Pay",
                                                    textColor: "#000",
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineGoogle */.P_r, {}),
                                                    disabled: !window.PaymentRequest || !altPaymentEnabled,
                                                    onClick: (data)=>{
                                                        setModalData({
                                                            ...modalData,
                                                            payment: {
                                                                ...modalData.payment,
                                                                method: "GOOGLE_PAY"
                                                            }
                                                        });
                                                    },
                                                    backgroundColor: modalData.payment.method === "GOOGLE_PAY" ? selectionColour : theme.backgroundColour
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                modalData.payment.method === "CARD" && modalData.paymentType !== graphql/* PaymentType.DirectDebit */.uG.DirectDebit && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col w-full pt-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-full mb-1 relative mt-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "".concat(theme.type === "DARK" ? "bg-midnight-dark" : "bg-white", " text-sm absolute -top-2 left-3.5 pl-1 pr-1"),
                                                        children: "Number"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardNumberElement, {
                                                        className: "h-13 bg-transparent border rounded-2xl px-4 py-5 text-sm outline-none",
                                                        options: {
                                                            style: {
                                                                base: {
                                                                    color: theme.textColour
                                                                }
                                                            }
                                                        },
                                                        onChange: (e)=>{
                                                            setStripeCardCompleted(e.complete);
                                                            setValidPaymentDetails((currentDetails)=>({
                                                                    ...currentDetails,
                                                                    number: e.complete
                                                                }));
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-full flex relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                        className: "relative w-1/2 mt-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "xs:hidden md:inline ".concat(theme.type === "DARK" ? "bg-midnight-dark" : "bg-white", " text-sm absolute -top-2 left-3.5 pl-1 pr-1"),
                                                                children: "Expiry date"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardExpiryElement, {
                                                                className: "h-13 bg-transparent border rounded-2xl px-4 py-5 text-sm outline-none mr-2",
                                                                options: {
                                                                    style: {
                                                                        base: {
                                                                            color: theme.textColour
                                                                        }
                                                                    }
                                                                },
                                                                onChange: (e)=>{
                                                                    setValidPaymentDetails((currentDetails)=>({
                                                                            ...currentDetails,
                                                                            mmaa: e.complete
                                                                        }));
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-1/2 relative mt-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "xs:hidden md:inline ".concat(theme.type === "DARK" ? "bg-midnight-dark" : "bg-white", " text-sm absolute -top-2 left-3.5 pl-1 pr-1"),
                                                                children: "Security Code"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardCvcElement, {
                                                                className: "h-13 bg-transparent border rounded-2xl px-4 py-5 text-smy outline-none",
                                                                options: {
                                                                    style: {
                                                                        base: {
                                                                            color: theme.textColour
                                                                        }
                                                                    }
                                                                },
                                                                onChange: (e)=>{
                                                                    setValidPaymentDetails((currentDetails)=>({
                                                                            ...currentDetails,
                                                                            cvc: e.complete
                                                                        }));
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                paymentError && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full h-px bg-gray-200 my-4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-red-500 text-xs",
                                            children: paymentError
                                        })
                                    ]
                                }),
                                modalData.paymentType !== graphql/* PaymentType.DirectDebit */.uG.DirectDebit && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-xs pt-4",
                                            children: "Our platform processes your data, including card details, exclusively to facilitate donations through the Stripe system. We do not store or retain any of your data."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "flex flex-row items-center justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "flex h-[40px] max-w-[200px]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stripe, {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "h-[250px]"
                                        })
                                    ]
                                })
                            ]
                        }),
                        modalData.paymentType === graphql/* PaymentType.DirectDebit */.uG.DirectDebit && (modalStage === null || modalStage === void 0 ? void 0 : modalStage.step) === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "font-medium",
                                    children: "Your Direct Debit details"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                    label: "Account holder name(s)",
                                    value: modalData.directDebit.name,
                                    onChange: (name)=>setModalData({
                                            ...modalData,
                                            directDebit: {
                                                ...modalData.directDebit,
                                                name
                                            }
                                        }),
                                    type: "text",
                                    placeholder: "Account holder name(s)",
                                    className: "bg-transparent rounded text-sm outline-none border-box pr-1",
                                    validations: {
                                        minLength: {
                                            value: 2,
                                            message: "Must be at least 2 characters"
                                        }
                                    },
                                    required: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "flex flex-row -mt-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                            className: "bg-transparent rounded text-sm outline-none border-box pr-1 w-1/2",
                                            label: "Account number",
                                            value: modalData.directDebit.number,
                                            onChange: (number)=>setModalData({
                                                    ...modalData,
                                                    directDebit: {
                                                        ...modalData.directDebit,
                                                        number
                                                    }
                                                }),
                                            type: "text",
                                            placeholder: "Account number",
                                            validations: {
                                                minLength: {
                                                    value: 8,
                                                    message: "Account number must be exactly 8 digits"
                                                },
                                                maxLength: {
                                                    value: 8,
                                                    message: "Account number must be exactly 8 digits"
                                                },
                                                pattern: {
                                                    value: /^\d{8}$/,
                                                    message: "Account number must consist of exactly 8 digits"
                                                }
                                            },
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                            className: "bg-transparent rounded text-sm outline-none border-box pr-1 w-1/2",
                                            label: "Sort Code",
                                            value: modalData.directDebit.sort,
                                            onChange: (sort)=>setModalData({
                                                    ...modalData,
                                                    directDebit: {
                                                        ...modalData.directDebit,
                                                        sort
                                                    }
                                                }),
                                            type: "text",
                                            placeholder: "Sort Code",
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "text-sm mb-1 mt-4",
                                    onClick: ()=>{
                                        setModalData({
                                            ...modalData,
                                            directDebit: {
                                                ...modalData.directDebit,
                                                confirmDirectDebit: !modalData.directDebit.confirmDirectDebit
                                            }
                                        });
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "checkbox",
                                            checked: modalData === null || modalData === void 0 ? void 0 : modalData.directDebit.confirmDirectDebit,
                                            className: "mr-2 pt-1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-bold cursor-pointer",
                                            children: "I confirm that I am able to authorise debits from the account, either as the account holder or on behalf of the multiple signatories to the account."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            show: modalStage.step === 3,
                            className: "flex flex-col px-2",
                            children: [
                                giftAidStep === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "my-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-lg font-bold mb-6",
                                            children: "Good news! This cause supports Gift Aid."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-sm mb-1",
                                            children: "Please confirm the statements below to ensure your donation is eligible."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-sm mb-1",
                                            children: "Charities receive 25% more at no extra cost to you"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "text-sm mb-1 mt-8",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: "✓"
                                                }),
                                                " This donation is my own money"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "text-sm mb-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: "✓"
                                                }),
                                                " I am not receiving anything in return for this donation"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "flex justify-center mt-2 mb-2 max-h-720:hidden",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                className: "w-1/2",
                                                src: GiftAid.src,
                                                width: 200,
                                                height: 200,
                                                alt: "Image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "text-sm mb-1 mt-8",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: modalData.payment.giftAid,
                                                    onChange: ()=>{
                                                        setModalData({
                                                            ...modalData,
                                                            payment: {
                                                                ...modalData.payment,
                                                                giftAid: !modalData.payment.giftAid
                                                            }
                                                        });
                                                    },
                                                    className: "mr-2 pt-1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-bold cursor-pointer",
                                                    onClick: ()=>{
                                                        setModalData({
                                                            ...modalData,
                                                            payment: {
                                                                ...modalData.payment,
                                                                giftAid: !modalData.payment.giftAid
                                                            }
                                                        });
                                                    },
                                                    children: "I agree and confirm"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                giftAidStep === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "my-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-lg font-bold mb-6",
                                            children: "Add Gift Aid"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-sm mb-3",
                                            children: "Charities receive 25% more at no extra cost to you"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-sm mb-3",
                                            children: "Gift Aid is tax relief that lets your charity claim an extra 25p for every \xa31 you give."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-sm mb-3",
                                            children: "I am a UK taxpayer and understand that if I pay less Income Tax and/or Capital Gains Tax than the amount of Gift Aid claimed on all my donations in that tax year it is my responsibility to pay any difference.\xa0 If you pay Income Tax at the higher or additional rate and want to receive the additional tax relief due to you, you must include all your Gift Aid donations on your Self-Assessment tax return or ask HM Revenue and Customs to adjust your tax code."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-sm mb-3",
                                            children: "Please inform us if you want to cancel this declaration/Change your name or home address/No longer pay sufficient tax on your income and/or capital gains."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "text-sm mb-3",
                                            children: [
                                                "Gift Aid is reclaimed by ",
                                                eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.organizationName,
                                                " from the tax you pay for the current tax year. Your home address is needed to identify you as a current taxpayer."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "flex justify-center mt-2 mb-2 max-h-700:hidden",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                className: "w-1/2",
                                                src: GiftAid.src,
                                                width: 200,
                                                height: 200,
                                                alt: "Image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "text-sm mb-1 mt-8",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: modalData.payment.giftAidConfirm,
                                                    onChange: ()=>{
                                                        setModalData({
                                                            ...modalData,
                                                            payment: {
                                                                ...modalData.payment,
                                                                giftAidConfirm: !modalData.payment.giftAidConfirm
                                                            }
                                                        });
                                                    },
                                                    className: "mr-2 pt-1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-bold cursor-pointer pb-[100px] md:pb-0",
                                                    onClick: ()=>{
                                                        setModalData({
                                                            ...modalData,
                                                            payment: {
                                                                ...modalData.payment,
                                                                giftAidConfirm: !modalData.payment.giftAidConfirm
                                                            }
                                                        });
                                                    },
                                                    children: "Yes, add Gift Aid"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                giftAidStep === "sussex" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "my-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-lg font-bold mb-6",
                                            children: "Add Gift Aid"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-sm mb-3",
                                            children: "Charities receive 25% more at no extra cost to you"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-sm mb-3",
                                            children: "Gift Aid is tax relief that lets your charity claim an extra 25p for every \xa31 you give."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-sm mb-3",
                                            children: "I am a UK taxpayer and I would like the University of Sussex to treat all donations I have made in the last four years and all donations I make in future as Gift Aid donations. I understand that if I pay less income tax and/or capital gains than the amount of Gift Aid claimed on all of my donations in a tax year by University of Sussex and all other charities and amateur sports clubs (CASCs) that I donate to, then it is my responsibility to pay any difference."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-sm mb-3",
                                            children: "If you pay a higher rate tax then you can claim extra relief on your donations."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-sm mb-3",
                                            children: "Please contact the Development and Alumni Relations Office on 01273 678258 or alumni@sussex.ac.uk if you want to cancel this or a previous declaration, change your contact details, or if you no longer pay sufficient tax on your income and/or capital gains."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "text-sm mb-1 mt-8",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: modalData.payment.giftAidConfirm,
                                                    onChange: ()=>{
                                                        setModalData({
                                                            ...modalData,
                                                            payment: {
                                                                ...modalData.payment,
                                                                giftAid: !modalData.payment.giftAidConfirm,
                                                                giftAidConfirm: !modalData.payment.giftAidConfirm
                                                            }
                                                        });
                                                    },
                                                    className: "mr-2 pt-1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-bold cursor-pointer pb-[100px] md:pb-0",
                                                    onClick: ()=>{
                                                        setModalData({
                                                            ...modalData,
                                                            payment: {
                                                                ...modalData.payment,
                                                                giftAidConfirm: !modalData.payment.giftAidConfirm
                                                            }
                                                        });
                                                    },
                                                    children: "Yes, I confirm I want to Gift Aid my donations."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "flex justify-center mt-2 mb-2 max-h-700:hidden",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                className: "w-1/2",
                                                src: GiftAid.src,
                                                width: 200,
                                                height: 200,
                                                alt: "Image"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            show: modalStage.step === 4,
                            className: "flex flex-col px-2 pb-10 md:pb-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "font-medium",
                                    children: "Add a Message for the Donor Wall:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "flex justify-start items-center -mt-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAreaInput/* TextAreaInput */.F, {
                                        className: "w-full mt-4",
                                        label: "Message (optional)",
                                        onChange: (data)=>{
                                            setModalData({
                                                ...modalData,
                                                message: data
                                            });
                                        },
                                        value: modalData === null || modalData === void 0 ? void 0 : modalData.message
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "font-medium mt-2 mb-1",
                                    children: "Visibility:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemPicker/* ItemPicker */.H, {
                                    itemClass: "!w-1/3",
                                    choices: visibilityChoices,
                                    onClick: (value)=>setModalData({
                                            ...modalData,
                                            visibility: value
                                        }),
                                    value: modalData.visibility
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "mt-4 text-sm",
                                    children: [
                                        "We",
                                        "'",
                                        "d love to keep in touch with you. Are you happy for us to use your contact details to keep you updated on the impact of your support, as well as other fundraising communications, campaigns and news?"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "text-sm mb-1 mt-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "checkbox",
                                            checked: modalData === null || modalData === void 0 ? void 0 : modalData.allowEmailContact,
                                            onChange: ()=>{
                                                setModalData({
                                                    ...modalData,
                                                    allowEmailContact: !modalData.allowEmailContact
                                                });
                                            },
                                            className: "mr-2 pt-1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "cursor-pointer text-sm",
                                            onClick: ()=>{
                                                setModalData({
                                                    ...modalData,
                                                    allowEmailContact: !modalData.allowEmailContact
                                                });
                                            },
                                            children: "Yes - you can contact me via email"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "text-sm mb-1 mt-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "checkbox",
                                            checked: modalData === null || modalData === void 0 ? void 0 : modalData.allowTelephoneContact,
                                            onChange: ()=>{
                                                setModalData({
                                                    ...modalData,
                                                    allowTelephoneContact: !modalData.allowTelephoneContact
                                                });
                                            },
                                            className: "mr-2 pt-1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "cursor-pointer text-sm",
                                            onClick: ()=>{
                                                setModalData({
                                                    ...modalData,
                                                    allowTelephoneContact: !modalData.allowTelephoneContact
                                                });
                                            },
                                            children: "Yes - you can contact me via telephone"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "h-[130px]"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            show: modalStage.step === 5,
                            className: "flex flex-col px-2 pb-10 md:pb-0 max-h-full h-full relative",
                            children: !payment3DSUrl ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "text-sm text-center",
                                        children: "You are about to donate"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "text-3xl font-bold text-center",
                                        children: "".concat(currencies/* default */.Z[organisationCurrency].symbol).concat((0,util/* roundAmount */.Bq)(amount)).concat(modalData.paymentType === graphql/* PaymentType.DirectDebit */.uG.DirectDebit ? " ".concat(modalData.selectedRecurrency === "Monthly" ? "a month" : modalData.selectedRecurrency === "Quarterly" ? "a quarter" : "a year") : "")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "text-sm text-center mt-4",
                                        children: "to fund"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "text-xl font-bold text-center",
                                        children: (ref17 = modalData === null || modalData === void 0 ? void 0 : modalData.program) !== null && ref17 !== void 0 ? ref17 : eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "flex justify-center mt-4 mb-4 max-h-700:hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(donationImg01, {})
                                    }),
                                    !feeAbsorption && platformFee > 0 && modalData.paymentType !== graphql/* PaymentType.DirectDebit */.uG.DirectDebit && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "text-sm mt-6",
                                                children: "To ensure that 100% of your intended donation goes towards making a positive impact, we encourage you to consider covering the small transaction fee associated with online donations"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "flex justify-center items-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleInput/* ToggleInput */.s, {
                                                    selected: modalData.payment.coverPlatformFee ? 1 : 0,
                                                    centerText: true,
                                                    testid: "cover-fee-input",
                                                    options: feeOptions,
                                                    className: "w-full mt-4",
                                                    value: modalData.payment.coverPlatformFee ? feeOptions[1] : feeOptions[0],
                                                    callback: (data)=>{
                                                        setModalData({
                                                            ...modalData,
                                                            payment: {
                                                                ...modalData.payment,
                                                                coverPlatformFee: data.toLowerCase().includes("yes"),
                                                                coverTrxFee: data.toLowerCase().includes("yes")
                                                            }
                                                        });
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "my-4 mt-8 text-right",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                className: "text-sm",
                                                children: [
                                                    "Payment Method:",
                                                    " ",
                                                    modalData.paymentType === graphql/* PaymentType.DirectDebit */.uG.DirectDebit ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Direct Debit"
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "font-bold",
                                                        children: PaymentMethods[modalData.payment.method]
                                                    })
                                                ]
                                            }),
                                            platformFee > 0 && modalData.paymentType !== graphql/* PaymentType.DirectDebit */.uG.DirectDebit && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                className: "text-sm",
                                                children: [
                                                    "Fees",
                                                    " ",
                                                    "(".concat(modalData.payment.coverPlatformFee ? "Covered by you" : "Deducted from the donation", ")"),
                                                    ":",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "font-bold",
                                                        children: [
                                                            "".concat(currencies/* default */.Z[organisationCurrency].symbol).concat((0,util/* roundAmount */.Bq)((0,Stripe_util/* getDonationTotal */.Ip)({
                                                                amount: amount * 100,
                                                                platformFee,
                                                                regionCode: (0,Stripe_util/* getBankingCountryByPaymentMethod */.zo)(paymentMethod),
                                                                coverPlatformFee: modalData.payment.coverPlatformFee
                                                            }).total / 100), " "),
                                                            (()=>{
                                                                // const { flat, percent } = getProcessorFees(
                                                                //   getBankingCountryByPaymentMethod(paymentMethod)
                                                                // )
                                                                return "(".concat(platformFee.toFixed(1), "%)");
                                                            })()
                                                        ]
                                                    })
                                                ]
                                            }),
                                            (modalData === null || modalData === void 0 ? void 0 : (ref12 = modalData.payment) === null || ref12 === void 0 ? void 0 : ref12.giftAid) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                className: "text-sm",
                                                children: [
                                                    "This donation can raise 25% more with gift aid:",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "".concat(currencies/* default */.Z[organisationCurrency].symbol).concat((0,util/* roundAmount */.Bq)(amount * 0.25))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    paymentError && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "mb-4 text-center items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-full h-px bg-gray-200 my-4"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-red-500 text-sm",
                                                children: paymentError
                                            })
                                        ]
                                    }),
                                    modalData.payment.method !== "CARD" && paymentRequest && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.PaymentRequestButtonElement, {
                                        options: {
                                            paymentRequest
                                        }
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                src: payment3DSUrl,
                                className: "!min-h-[600px]"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            show: modalStage.step === 6,
                            className: "flex flex-col py-4 pt-4 px-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "text-2xl mt-10 font-bold text-center",
                                    children: [
                                        "You donated ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-bold text-3xl",
                                            style: {
                                                color: StaticColours.v2.blue
                                            },
                                            children: "".concat(currencies/* default */.Z[organisationCurrency].symbol).concat(amount)
                                        }),
                                        modalData.paymentType === graphql/* PaymentType.DirectDebit */.uG.DirectDebit ? " ".concat(modalData.selectedRecurrency === "Monthly" ? "a month" : modalData.selectedRecurrency === "Quarterly" ? "a quarter" : "a year") : "",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "text-sm text-center mt-2",
                                    children: "Thank you for your support!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "flex justify-center mt-4 mb-4 max-h-700:hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(donationImg02/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "my-4 mt-10 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-lg font-medium",
                                            children: "Please share our fundraiser!"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-sm mb-2",
                                            children: "Help us to achieve our goals, share with your friends."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "text-lg mt-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* FacebookShareButton */.Dk, {
                                                    url: pageUrl,
                                                    className: "mr-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* FacebookIcon */.Vq, {
                                                        bgStyle: {
                                                            fill: selectionColour
                                                        },
                                                        size: "48px",
                                                        round: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* TwitterShareButton */.B, {
                                                    url: pageUrl,
                                                    className: "mr-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* TwitterIcon */.Zm, {
                                                        bgStyle: {
                                                            fill: selectionColour
                                                        },
                                                        size: "48px",
                                                        round: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* LinkedinShareButton */.r2, {
                                                    url: pageUrl,
                                                    className: "mr-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* LinkedinIcon */.pA, {
                                                        bgStyle: {
                                                            fill: selectionColour
                                                        },
                                                        size: "48px",
                                                        round: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* WhatsappShareButton */.N0, {
                                                    url: pageUrl,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* WhatsappIcon */.ud, {
                                                        bgStyle: {
                                                            fill: selectionColour
                                                        },
                                                        size: "48px",
                                                        round: true
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: showInline ? "!sticky bottom-0 flex flex-row w-full items-center justify-center bg-white pb-4 z-10 pt-2 " : "!sticky bottom-0 z-10 rounded-br-xl rounded-bl-xl pt-3 w-full flex justify-end space-x-reverse space-x-2 shadow-[0_-2px_4px_-1px_rgba(0,0,0,0.3)] !pb-3",
                    style: {
                        backgroundColor: theme.backgroundColour,
                        paddingBottom: "env(safe-area-inset-bottom)"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "mr-4 border-0 text-xs mt-[1px]",
                            children: [
                                "Need Help? Send us an ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "email at ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "hello@forumm.to"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            onClick: ()=>{
                                const container = document.getElementById("modal");
                                if ((container === null || container === void 0 ? void 0 : container.firstElementChild) instanceof HTMLElement) {
                                    container.firstElementChild.scrollTop = 0;
                                }
                                if (modalStage.step === 0 && setIsOpen) return setIsOpen(false);
                                if (modalStage.step == 1) return setModalStage(ModalFlow[0]);
                                if (modalStage.step == 2) return setModalStage(ModalFlow[1]);
                                if (modalStage.step == 3) {
                                    if (giftAidStep === 2) {
                                        setGiftAidStep(1);
                                        return;
                                    }
                                    if (disablePayment) setModalStage(ModalFlow[1]);
                                    else setModalStage(ModalFlow[2]);
                                    return;
                                }
                                if (modalStage.step == 4) {
                                    if (configSkipGiftAidStep) return setModalStage(ModalFlow[2]);
                                    return setModalStage(ModalFlow[3]);
                                }
                                if (modalStage.step == 5) return setModalStage(ModalFlow[4]);
                                if (programs && (programs === null || programs === void 0 ? void 0 : programs.length) > 0) setModalStage(ModalFlow[0]);
                                else setModalStage(ModalFlow[1]);
                                if (!disablePayment) {
                                    if (setIsOpen) setIsOpen(false);
                                }
                            },
                            className: "mr-2",
                            size: "auto",
                            type: "modal",
                            textColor: "#000",
                            title: modalStage.step === 6 ? "Close" : modalStage.step === 0 ? "Cancel" : "Back"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            show: modalStage.step < 5,
                            disabled: isContinueDisabled,
                            onClick: ()=>{
                                const container = document.getElementById("modal");
                                if ((container === null || container === void 0 ? void 0 : container.firstElementChild) instanceof HTMLElement) {
                                    container.firstElementChild.scrollTop = 0;
                                }
                                handleSetModalStage(ModalFlow[modalStage.step + 1]);
                            },
                            size: "auto",
                            type: "modal",
                            textColor: "#000",
                            title: "Continue"
                        }),
                        modalData.payment.method === "CARD" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            show: modalStage.step === 5,
                            disabled: disable || loading,
                            loading: loading,
                            title: "".concat(formCTA !== null && formCTA !== void 0 ? formCTA : "Donate"),
                            size: "auto",
                            textColor: "#000",
                            onClick: (e)=>{
                                handleSubmit(e);
                            }
                        })
                    ]
                })
            ]
        });
        if (showInline) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
            className: "w-full",
            children: innerConent
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            show: isOpen || false,
            setShow: (val)=>{
                if (!val) {
                    setModalData((0,lodash.cloneDeep)(initialState));
                    setModalStage(ModalFlow[0]);
                    setGiftAidStep(1);
                    setLoading(false);
                    setStripeCardCompleted(false);
                    setPaymentMethod(undefined);
                }
                if (setIsOpen) setIsOpen(val);
            },
            title: "Save Confirmation",
            className: "p-0 sm:min-w-[650px]",
            zIndex: "9999",
            version: true,
            children: innerConent
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    };
    return donationFormModal();
};
/* harmony default export */ var donation_DonationForm = (DonationForm);


/***/ }),

/***/ 94745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ ItemPicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51773);



const ItemPicker = (param)=>{
    let { choices , value , itemClass , onClick  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex",
        children: choices.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                className: "text-[9px] md:text-xs flex pointer items-center justify-center border border-gray-400 w-1/6 ".concat(index !== choices.length - 1 ? "lg:mr-1" : "", "  min-h-[56px] cursor-pointer !px-1 ").concat(itemClass, " ").concat(value === item.value ? "bg-forumm-blue-light-2" : "", " \n      ").concat(index === 0 ? "rounded-l-2xl" : "", " \n      ").concat(index === choices.length - 1 ? "rounded-r-2xl" : "", " \n      ").concat(index > 0 && index < choices.length - 1 ? "!rounded-[0px]" : ""),
                onClick: ()=>onClick(item.value),
                children: "".concat(value === item.value ? "✓ " : "").concat(item.title)
            }, item.title))
    });
};


/***/ }),

/***/ 95746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ GET_EVENT_BY_DONATION_URL; }
/* harmony export */ });
/* harmony import */ var _graphql_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66703);

const GET_EVENT_BY_DONATION_URL = (0,_graphql_generated__WEBPACK_IMPORTED_MODULE_0__/* .graphql */ .B)("\n  query getEventByDonationUrl($input: GetEventByDonationUrlInput!) {\n    getEventByDonationUrl(input: $input) {\n      ...EventData\n      __typename\n      fundraising {\n        id\n        title\n        description\n        goal\n        feeAbsorption\n        programs {\n          title\n          description\n          goal\n          media {\n            title\n            body\n            platform\n            url\n          }\n          active\n          enabled\n        }\n        media {\n          title\n          body\n          platform\n          url\n        }\n        transactions {\n          selectedProgram\n          fee\n          total\n          email\n          amount\n          created\n          currency\n          coverFee\n          address\n          giftAid\n          firstName\n          lastName\n          donation\n        }\n      }\n    }\n  }\n\n  fragment EventData on Event {\n    eventId\n    isPublished\n    organizerId\n    event {\n      bannerImage\n      description\n      eventMainColour\n      eventBackgroundColour\n      eventTextColour\n      endDateTime\n      registrationCloseDateTime\n      shortDescription\n      startDateTime\n      title\n      organizationName\n      thumbnailImage\n      publiclyListed\n      currency\n      fixedAdminFee\n      eventType\n      eventLocation\n      eventLocationMapUrl\n      eventLocationMapLink\n      donationUrl\n    }\n    donations {\n      email\n      fullName\n      amount\n      message\n      created\n      currency\n      avatarUrl\n      selectedProgram\n    }\n  }\n");


/***/ }),

/***/ 16458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zo": function() { return /* binding */ getBankingCountryByPaymentMethod; },
  "Ip": function() { return /* binding */ getDonationTotal; },
  "T3": function() { return /* binding */ getStripeConnectStatus; }
});

// UNUSED EXPORTS: getProcessorFees

;// CONCATENATED MODULE: ./libs/Stripe/processor-fees.ts
//Flat values are represented as the unit for said currency (GBP = pence, USD = cent).
const processor_fees_EUROPE_ECONOMIC_AREA = (/* unused pure expression or super */ null && ([
    "AT",
    "BE",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FI",
    "FR",
    "DE",
    "GI",
    "GR",
    "HU",
    "IS",
    "IE",
    "IT",
    "LV",
    "LI",
    "LT",
    "LU",
    "MT",
    "NL",
    "NO",
    "PL",
    "PT",
    "RO",
    "SK",
    "SI",
    "ES",
    "SE"
]));
const processor_fees_STRIPE_PAYMENT_FEES = {
    GBP: {
        percent: 1.5,
        flat: 20
    },
    EEA: {
        percent: 2.5,
        flat: 20
    },
    INTERNATIONAL: {
        percent: 3.25,
        flat: 20
    }
};

;// CONCATENATED MODULE: ./libs/Stripe/util.ts

const getStripeConnectStatus = (merchantAccount)=>{
    var ref;
    const required = (ref = merchantAccount === null || merchantAccount === void 0 ? void 0 : merchantAccount.required) !== null && ref !== void 0 ? ref : [];
    const isMerchant = !!(merchantAccount === null || merchantAccount === void 0 ? void 0 : merchantAccount.merchantAccountExists);
    const chargesEnabled = !!(merchantAccount === null || merchantAccount === void 0 ? void 0 : merchantAccount.chargesEnabled);
    const onboardingComplete = isMerchant && required.length < 1;
    return {
        isMerchant,
        chargesEnabled,
        onboardingComplete,
        required,
        isReady: isMerchant && chargesEnabled && onboardingComplete
    };
};
const getBankingCountryByPaymentMethod = (paymentMethod)=>{
    if (!paymentMethod) return undefined;
    const { type , card  } = paymentMethod;
    var ref;
    return (ref = card === null || card === void 0 ? void 0 : card.country) !== null && ref !== void 0 ? ref : undefined;
};
const getProcessorFees = (regionCode)=>{
    if (!regionCode) return STRIPE_PAYMENT_FEES.INTERNATIONAL;
    if (regionCode === "GB") return STRIPE_PAYMENT_FEES.GBP;
    if (EUROPE_ECONOMIC_AREA.includes(regionCode)) return STRIPE_PAYMENT_FEES.EEA;
    return STRIPE_PAYMENT_FEES.INTERNATIONAL;
};
const getDonationTotal = (param)=>{
    let { amount , platformFee , regionCode , coverPlatformFee  } = param;
    let donationAmountCents = amount;
    let totalDonationCents = amount;
    const platformFeeAmountCents = Math.ceil(donationAmountCents * (platformFee / 100));
    if (coverPlatformFee) {
        totalDonationCents = donationAmountCents + platformFeeAmountCents;
    }
    donationAmountCents = totalDonationCents - platformFeeAmountCents;
    return {
        donation: donationAmountCents,
        platformFee: platformFeeAmountCents,
        total: totalDonationCents,
        regionCode
    };
};


/***/ })

}]);